// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type CoreApplicationSummary = {
    readonly id: number;
    readonly role_id: number;
    readonly job_title: string;
    readonly district_name: string;
    readonly status: CoreInternalCandidateApplicationStatusEnum;
    readonly updated: string;
    readonly date_submitted: string | null;
};

/**
 * * `draft` - draft
 * * `draft_not_submittable` - draft_not_submittable
 * * `submitted` - submitted
 */
export const CoreInternalCandidateApplicationStatusEnum = {
    DRAFT: 'draft',
    DRAFT_NOT_SUBMITTABLE: 'draft_not_submittable',
    SUBMITTED: 'submitted'
} as const;

/**
 * * `draft` - draft
 * * `draft_not_submittable` - draft_not_submittable
 * * `submitted` - submitted
 */
export type CoreInternalCandidateApplicationStatusEnum = typeof CoreInternalCandidateApplicationStatusEnum[keyof typeof CoreInternalCandidateApplicationStatusEnum];

export type CoreApplicationSchoolPreferences = {
    interested_in_all: boolean;
    selected_schools: Array<string>;
    open_to_other: boolean;
};

export type CoreApplicationResume = {
    readonly file_name: string;
    readonly url: string;
};

export type CoreApplicationReference = {
    readonly id: number;
    readonly first_name: string;
    readonly last_name: string | null;
    readonly title: string;
    readonly organization: string | null;
    readonly relationship: string;
    readonly years_known: string;
    readonly email: string;
    readonly phone: string;
};

export type CoreApplicationQuestion = {
    id: number;
    question: string;
    description?: string | null;
    type: CoreApplicationAnswerTypeEnum;
    scope: CoreApplicationAnswerScopeEnum;
    required: boolean;
    options?: Array<string>;
};

/**
 * * `global` - Global
 * * `job` - Job
 */
export const CoreApplicationAnswerScopeEnum = { GLOBAL: 'global', JOB: 'job' } as const;

/**
 * * `global` - Global
 * * `job` - Job
 */
export type CoreApplicationAnswerScopeEnum = typeof CoreApplicationAnswerScopeEnum[keyof typeof CoreApplicationAnswerScopeEnum];

/**
 * * `open_response` - Open Response
 * * `yes_no` - Yes No
 * * `single_choice` - Single Choice
 * * `multiple_choice` - Multiple Choice
 * * `statement_checkbox` - Statement Checkbox
 * * `attachment` - Attachment
 * * `video_link` - Video Link
 */
export const CoreApplicationAnswerTypeEnum = {
    OPEN_RESPONSE: 'open_response',
    YES_NO: 'yes_no',
    SINGLE_CHOICE: 'single_choice',
    MULTIPLE_CHOICE: 'multiple_choice',
    STATEMENT_CHECKBOX: 'statement_checkbox',
    ATTACHMENT: 'attachment',
    VIDEO_LINK: 'video_link'
} as const;

/**
 * * `open_response` - Open Response
 * * `yes_no` - Yes No
 * * `single_choice` - Single Choice
 * * `multiple_choice` - Multiple Choice
 * * `statement_checkbox` - Statement Checkbox
 * * `attachment` - Attachment
 * * `video_link` - Video Link
 */
export type CoreApplicationAnswerTypeEnum = typeof CoreApplicationAnswerTypeEnum[keyof typeof CoreApplicationAnswerTypeEnum];

export type CoreApplicationLanguage = {
    readonly id: number;
    readonly language: number;
    readonly proficiency: number | null;
};

export type CoreApplicationExperience = {
    readonly id: number;
    readonly employer: string;
    readonly title: string;
    readonly description: string;
    readonly subjects: Array<string>;
    readonly grades: Array<number>;
    readonly experience_types: Array<string>;
    readonly reason_for_leaving: string;
    readonly reference_name: string;
    readonly reference_phone: string;
    readonly reference_email: string;
    readonly do_not_contact: boolean;
    readonly start_date: string;
    readonly end_date: string | null;
    readonly current: boolean;
};

export type CoreApplicationExamResult = {
    name: string;
    score: string | null;
    max_score: string | null;
};

export type CoreApplicationExam = {
    readonly id: number;
    exam: string;
    subject: string | null;
    custom_name: string | null;
    results: Array<CoreApplicationExamResult>;
};

export type CoreApplicationEducation = {
    readonly id: number;
    readonly school_id: number | null;
    readonly school_custom: string | null;
    readonly major: number;
    readonly degree: number;
    readonly gpa: string | null;
    readonly gpa_out_of: string | null;
    readonly start_date: string | null;
    readonly end_date: string | null;
    readonly current: boolean;
};

export type CoreApplicationCredential = {
    readonly id: number;
    readonly state: string;
    readonly subject_id: number;
    readonly subject_label: string;
    readonly license_number: string | null;
    readonly grade_id: number | null;
    readonly status_id: number | null;
    readonly issue_date: string | null;
    readonly expiration_date: string | null;
};

export type CoreApplicationCertificate = {
    value: string;
    custom_name: string | null;
};

export type CoreApplicationApplicant = {
    readonly first_name: string;
    readonly last_name: string;
    readonly middle_name: string | null;
    readonly email: string;
    readonly phone: string | null;
    readonly address_street: string;
    readonly address_apt: string | null;
    readonly city: string;
    readonly state: string;
    readonly zip_code: string;
    readonly country: string | null;
    readonly states_lived_in: Array<string>;
    readonly gender: string | null;
    readonly race_ethnicity: string | null;
    readonly years_experience: number | null;
    readonly ssn_provided: boolean;
    readonly birthdate: string | null;
};

export type CoreApplicationAnswer = {
    question: CoreApplicationQuestion;
    answer: unknown | null;
};

export type CoreValidTokenResponse = {
    valid: true;
    user_id: number;
};

/**
 * * `candidate` - candidate
 * * `school_user` - school_user
 * * `school_admin` - school_admin
 * * `district_user` - district_user
 * * `district_admin` - district_admin
 * * `super_admin` - super_admin
 */
export const CoreUserTypeEnum = {
    CANDIDATE: 'candidate',
    SCHOOL_USER: 'school_user',
    SCHOOL_ADMIN: 'school_admin',
    DISTRICT_USER: 'district_user',
    DISTRICT_ADMIN: 'district_admin',
    SUPER_ADMIN: 'super_admin'
} as const;

/**
 * * `candidate` - candidate
 * * `school_user` - school_user
 * * `school_admin` - school_admin
 * * `district_user` - district_user
 * * `district_admin` - district_admin
 * * `super_admin` - super_admin
 */
export type CoreUserTypeEnum = typeof CoreUserTypeEnum[keyof typeof CoreUserTypeEnum];

export type CoreUpdateStatusTrigger = {
    trigger_type: CoreTriggerTypeEnum;
    new_status_id: number;
};

/**
 * * `question_answer` - Question Answer
 * * `update_status` - Update Status
 * * `send_reference_check` - Send Reference Check
 */
export const CoreTriggerTypeEnum = {
    QUESTION_ANSWER: 'question_answer',
    UPDATE_STATUS: 'update_status',
    SEND_REFERENCE_CHECK: 'send_reference_check'
} as const;

/**
 * * `question_answer` - Question Answer
 * * `update_status` - Update Status
 * * `send_reference_check` - Send Reference Check
 */
export type CoreTriggerTypeEnum = typeof CoreTriggerTypeEnum[keyof typeof CoreTriggerTypeEnum];

export type CoreUpdateStatusAction = {
    action_type: CoreActionTypeEnum;
    new_status_id: number;
};

/**
 * * `question_answer` - Question Answer
 * * `update_status` - Update Status
 * * `send_reference_check` - Send Reference Check
 */
export const CoreActionTypeEnum = {
    QUESTION_ANSWER: 'question_answer',
    UPDATE_STATUS: 'update_status',
    SEND_REFERENCE_CHECK: 'send_reference_check'
} as const;

/**
 * * `question_answer` - Question Answer
 * * `update_status` - Update Status
 * * `send_reference_check` - Send Reference Check
 */
export type CoreActionTypeEnum = typeof CoreActionTypeEnum[keyof typeof CoreActionTypeEnum];

export type CoreTokenValidationResult = CoreValidTokenResponse | CoreInvalidTokenResponse;

export type CoreInvalidTokenResponse = {
    valid: false;
    detail: string;
};

export type CoreTokenValidationRequest = {
    token: string;
};

/**
 * * `pending` - Pending
 * * `approved` - Approved
 * * `rejected` - Rejected
 */
export const CoreStatusDe3Enum = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
} as const;

/**
 * * `pending` - Pending
 * * `approved` - Approved
 * * `rejected` - Rejected
 */
export type CoreStatusDe3Enum = typeof CoreStatusDe3Enum[keyof typeof CoreStatusDe3Enum];

/**
 * * `Draft` - Draft
 * * `Submitted` - Submitted
 * * `Active` - Active
 * * `Archived` - Archived
 */
export const CoreStatus4C5Enum = {
    0: 0,
    10: 10,
    20: 20,
    30: 30
} as const;

/**
 * * `Draft` - Draft
 * * `Submitted` - Submitted
 * * `Active` - Active
 * * `Archived` - Archived
 */
export type CoreStatus4C5Enum = typeof CoreStatus4C5Enum[keyof typeof CoreStatus4C5Enum];

export type CoreStatus = {
    readonly id: number;
    label: string;
    readonly status_type: string;
};

/**
 * * `1` - Not Specified
 * * `2` - Immediate
 * * `3` - Next School Year
 * * `4` - Specific Date
 */
export const CoreStartDateTypeEnum = {
    1: 1,
    2: 2,
    3: 3,
    4: 4
} as const;

/**
 * * `1` - Not Specified
 * * `2` - Immediate
 * * `3` - Next School Year
 * * `4` - Specific Date
 */
export type CoreStartDateTypeEnum = typeof CoreStartDateTypeEnum[keyof typeof CoreStartDateTypeEnum];

export type CoreSendReferenceCheckAction = {
    action_type: CoreActionTypeEnum;
    reference_template_id: number;
};

export type CoreScorecardWrite = {
    readonly id: number;
    custom_scorecard_id: number;
    scorecard_complete?: boolean;
    include_cumulative_score?: boolean;
    include_rating_questions?: boolean | null;
    include_rubric_questions?: boolean | null;
    show_total_on_preview?: boolean | null;
    cumulative_score?: number | null;
    max_cumulative_score?: number | null;
    include_final_recommendation?: boolean;
    include_maybe_option?: boolean | null;
    show_answer_on_preview?: boolean | null;
    final_recommendation?: CoreFinalRecommendationEnum | CoreNullEnum;
    answers: Array<CoreScorecardAnswerCreate>;
};

export type CoreScorecardAnswerCreate = {
    readonly id: number;
    question_id: number;
    answer_text?: string | null;
    multi_select?: boolean | null;
    mc_answer?: Array<string> | null;
    answer_rubric?: number | null;
    answer_rating?: number | null;
    attachment?: string | null;
};

export type CoreNullEnum = null;

/**
 * * `final_recommendation/yes` - Yes
 * * `final_recommendation/maybe` - Maybe
 * * `final_recommendation/no` - No
 */
export const CoreFinalRecommendationEnum = {
    FINAL_RECOMMENDATION_YES: 'final_recommendation/yes',
    FINAL_RECOMMENDATION_MAYBE: 'final_recommendation/maybe',
    FINAL_RECOMMENDATION_NO: 'final_recommendation/no'
} as const;

/**
 * * `final_recommendation/yes` - Yes
 * * `final_recommendation/maybe` - Maybe
 * * `final_recommendation/no` - No
 */
export type CoreFinalRecommendationEnum = typeof CoreFinalRecommendationEnum[keyof typeof CoreFinalRecommendationEnum];

export type CoreScorecardQuestion = {
    readonly id: number;
    question_text?: string;
    is_required?: boolean;
    readonly question_type: number;
    mc_options?: Array<string> | null;
    scale?: number | null;
    rubric_columns?: unknown | null;
    multi_select?: boolean | null;
    show_total_on_preview?: boolean | null;
    include_maybe_option?: boolean | null;
    directions?: string | null;
};

export type CoreScorecardList = {
    readonly id: number;
    hiring_request_id: number;
    readonly template: {
        id: number;
        title: string;
    } | null;
    readonly submitted_by: {
        name: string;
        email: string;
        title: string;
    };
    readonly created: string;
    scorecard_complete?: boolean;
    include_cumulative_score?: boolean;
    include_rating_questions?: boolean | null;
    include_rubric_questions?: boolean | null;
    show_total_on_preview?: boolean | null;
    cumulative_score?: number | null;
    max_cumulative_score?: number | null;
    include_final_recommendation?: boolean;
    include_maybe_option?: boolean | null;
    show_answer_on_preview?: boolean | null;
    readonly final_recommendation: string | null;
    answers: Array<CoreScorecardAnswer>;
    is_universal?: boolean;
};

export type CoreScorecardAnswer = {
    readonly id: number;
    is_required?: boolean;
    question: CoreScorecardQuestion;
    answer_text?: string | null;
    multi_select?: boolean | null;
    mc_answer?: Array<string> | null;
    answer_rubric?: number | null;
    answer_rating?: number | null;
    readonly attachment: string | null;
};

export type CoreSchoolRoleVacancy = {
    readonly id: number;
    school_id: number;
    ftes_total?: number | null;
    school_name: string;
    visible_to_school_admin?: boolean;
};

export type CoreSchoolPreferencesQuestion = {
    id?: number;
    readonly role: number | null;
    question_set?: number | null;
    is_automatic_list: boolean;
    school_choices: Array<number>;
    order?: number;
    readonly question_type: string;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    included_in_preview?: boolean;
};

/**
 * * `1` - Hourly
 * * `2` - Weekly
 * * `3` - Monthly
 * * `4` - Yearly
 * * `5` - Daily
 */
export const CoreSalaryTypeEnum = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * * `1` - Hourly
 * * `2` - Weekly
 * * `3` - Monthly
 * * `4` - Yearly
 * * `5` - Daily
 */
export type CoreSalaryTypeEnum = typeof CoreSalaryTypeEnum[keyof typeof CoreSalaryTypeEnum];

export type CoreRoleVacancy = {
    district_ftes_total: number;
    readonly schoolroles: Array<CoreSchoolRoleVacancy>;
};

export type CoreRoleSettings = {
    readonly role_sections: Array<CoreRoleSection>;
    readonly statuses_available: Array<CoreStatus>;
    internal_only: boolean;
    external_date?: string | null;
    requisition_number?: string | null;
    /**
     * If the district is SJUSD (ie. San Jose Unified School District) we return a hardcoded value
     * for the external jobboard. Otherwise, we default to returning the district slug.
     */
    readonly district_jobboard_code: string;
    internal_requirements_specified: boolean;
};

export type CoreRoleSection = {
    readonly id: number;
    readonly section: string;
    visible?: boolean;
    required?: boolean;
    visible_internal?: boolean;
    required_internal?: boolean;
};

export type CoreRoleQuestions = {
    readonly requiredapplicationattachment_set: Array<CoreRequiredApplicationAttachment>;
    readonly school_preferences_question: CoreSchoolPreferencesQuestion;
    readonly custom_questions: Array<CoreCustomQuestionSerializerWithTags>;
    readonly questions: Array<CoreNimbleRoleQuestion>;
    readonly question_sets: Array<CoreQuestionSet>;
    question_sets_order: Array<CoreQuestionSetOrder>;
};

export type CoreQuestionSetOrder = {
    uuid: string;
    order: number;
    is_role_qs?: boolean;
};

export type CoreQuestionSet = {
    uuid?: string;
    title: string;
    roles?: Array<number>;
    id?: number;
    requiredapplicationattachment_set?: Array<CoreRequiredApplicationAttachment>;
    custom_questions?: Array<CoreCustomQuestionSerializerWithTags>;
    nimble_rolequestion_set?: Array<CoreNimbleRoleQuestion>;
    school_preferences_question?: Array<CoreSchoolPreferencesQuestion> | null;
    readonly items: string;
    readonly is_role_qs: string;
    readonly is_qs: string;
};

/**
 * Serializer for NimbleQuestions <> Role/SchoolRole through relationship.
 */
export type CoreNimbleRoleQuestion = {
    id?: number;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    nimblequestion_id: number;
    order: number;
    readonly question: string;
    readonly question_type: string;
    readonly source: number;
    included_in_preview?: boolean;
};

export type CoreQuestionAutoTag = {
    /**
     * One of the possible answers to the question linked
     */
    option: string;
    tag_id: number;
};

/**
 * * `question_type/open_response` - Open Response
 * * `question_type/yes_no` - Yes No
 * * `question_type/multiple_choice` - Multiple Choice
 * * `question_type/statement_checkbox` - Statement Checkbox
 * * `question_type/direction_text` - Direction Text
 */
export const CoreQuestionType4A9Enum = {
    QUESTION_TYPE_OPEN_RESPONSE: 'question_type/open_response',
    QUESTION_TYPE_YES_NO: 'question_type/yes_no',
    QUESTION_TYPE_MULTIPLE_CHOICE: 'question_type/multiple_choice',
    QUESTION_TYPE_STATEMENT_CHECKBOX: 'question_type/statement_checkbox',
    QUESTION_TYPE_DIRECTION_TEXT: 'question_type/direction_text'
} as const;

/**
 * * `question_type/open_response` - Open Response
 * * `question_type/yes_no` - Yes No
 * * `question_type/multiple_choice` - Multiple Choice
 * * `question_type/statement_checkbox` - Statement Checkbox
 * * `question_type/direction_text` - Direction Text
 */
export type CoreQuestionType4A9Enum = typeof CoreQuestionType4A9Enum[keyof typeof CoreQuestionType4A9Enum];

export type CoreCustomQuestionSerializerWithTags = {
    readonly district: number;
    role?: number | null;
    id?: number;
    prompt: string;
    is_legal?: boolean;
    is_district_default?: boolean;
    question_type: CoreQuestionType4A9Enum;
    hint?: string;
    mc_options?: Array<string> | null;
    multi_select?: boolean | null;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    order?: number;
    included_in_preview?: boolean;
    autotags?: Array<CoreQuestionAutoTag> | null;
};

/**
 * * `question_type/attachment` - Attachment
 * * `question_type/video_link` - Video Link
 */
export const CoreRequiredApplicationAttachmentQuestionTypeEnum = { QUESTION_TYPE_ATTACHMENT: 'question_type/attachment', QUESTION_TYPE_VIDEO_LINK: 'question_type/video_link' } as const;

/**
 * * `question_type/attachment` - Attachment
 * * `question_type/video_link` - Video Link
 */
export type CoreRequiredApplicationAttachmentQuestionTypeEnum = typeof CoreRequiredApplicationAttachmentQuestionTypeEnum[keyof typeof CoreRequiredApplicationAttachmentQuestionTypeEnum];

export type CoreRequiredApplicationAttachment = {
    id?: number;
    title: string;
    description?: string | null;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    question_type: CoreRequiredApplicationAttachmentQuestionTypeEnum;
    order?: number;
};

export type CoreRoleOverviewDistrict = {
    readonly id: number;
    name: string;
};

export type CoreRoleOverview = {
    title: string;
    readonly fulltime: string;
    district: CoreRoleOverviewDistrict;
    status: number;
    active_status: number;
};

export type CoreRoleDetailsSchool = {
    readonly id: number;
    name: string;
    location?: string;
};

export type CoreRoleDetails = {
    readonly id: number;
    title: string;
    description?: string | null;
    benefits?: string | null;
    requirements_text?: string;
    date_posted?: string | null;
    status?: CoreStatus4C5Enum;
    hiring_season?: CoreHiringSeasonEnum;
    readonly subjects: Array<string>;
    readonly categories: Array<string>;
    grades?: Array<CoreGradesEnum>;
    languages?: Array<-1 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 18 | 19 | 20 | 21 | 999> | null;
    readonly created: string;
    readonly updated: string;
    deadline?: string | null;
    salary_min?: number | null;
    salary_max?: number | null;
    salary_type?: CoreSalaryTypeEnum | CoreNullEnum;
    start_date?: string | null;
    start_date_type?: CoreStartDateTypeEnum;
    end_date?: string | null;
    readonly school: CoreRoleDetailsSchool;
    fulltime?: number | null;
    is_template?: boolean;
    contact?: string;
    active_status?: CoreActiveStatusEnum | CoreNullEnum;
    district_id: number;
    readonly schools: Array<{
        [key: string]: unknown;
    }>;
    readonly district_jobboard_slug: string;
};

/**
 * * `Closed` - Closed
 * * `Open` - Open
 */
export const CoreActiveStatusEnum = { 0: 0, 1: 1 } as const;

/**
 * * `Closed` - Closed
 * * `Open` - Open
 */
export type CoreActiveStatusEnum = typeof CoreActiveStatusEnum[keyof typeof CoreActiveStatusEnum];

/**
 * * `-1` - None
 * * `0` - Early Childhood
 * * `1` - First Grade
 * * `2` - Second Grade
 * * `3` - Third Grade
 * * `4` - Fourth Grade
 * * `5` - Fifth Grade
 * * `6` - Sixth Grade
 * * `7` - Seventh Grade
 * * `8` - Eighth Grade
 * * `9` - Ninth Grade
 * * `10` - Tenth Grade
 * * `11` - Eleventh Grade
 * * `12` - Twelfth Grade
 * * `13` - Kindergarten
 */
export const CoreGradesEnum = {
    '-1': -1,
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12,
    13: 13
} as const;

/**
 * * `-1` - None
 * * `0` - Early Childhood
 * * `1` - First Grade
 * * `2` - Second Grade
 * * `3` - Third Grade
 * * `4` - Fourth Grade
 * * `5` - Fifth Grade
 * * `6` - Sixth Grade
 * * `7` - Seventh Grade
 * * `8` - Eighth Grade
 * * `9` - Ninth Grade
 * * `10` - Tenth Grade
 * * `11` - Eleventh Grade
 * * `12` - Twelfth Grade
 * * `13` - Kindergarten
 */
export type CoreGradesEnum = typeof CoreGradesEnum[keyof typeof CoreGradesEnum];

/**
 * * `0` - Na
 * * `1` - Y2017 2018
 * * `2` - Y2018 2019
 * * `3` - Y2019 2020
 * * `4` - Y2020 2021
 * * `5` - Y2021 2022
 * * `6` - Y2022 2023
 * * `7` - Y2023 2024
 * * `8` - Y2024 2025
 * * `9` - Y2025 2026
 * * `10` - Y2026 2027
 * * `11` - Y2027 2028
 * * `12` - Y2028 2029
 */
export const CoreHiringSeasonEnum = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12
} as const;

/**
 * * `0` - Na
 * * `1` - Y2017 2018
 * * `2` - Y2018 2019
 * * `3` - Y2019 2020
 * * `4` - Y2020 2021
 * * `5` - Y2021 2022
 * * `6` - Y2022 2023
 * * `7` - Y2023 2024
 * * `8` - Y2024 2025
 * * `9` - Y2025 2026
 * * `10` - Y2026 2027
 * * `11` - Y2027 2028
 * * `12` - Y2028 2029
 */
export type CoreHiringSeasonEnum = typeof CoreHiringSeasonEnum[keyof typeof CoreHiringSeasonEnum];

export type CoreRoleActivityFeed = {
    id: number;
    readonly actor: {
        [key: string]: string;
    };
    verb: string;
    published: string;
    readonly action_object: {
        [key: string]: string;
    };
};

export type CoreReferenceCheckWrite = {
    readonly id: number;
    reference_id?: number;
    submitted_by_name?: string | null;
    submitted_by_title?: string | null;
    readonly submitted_by: string;
    readonly created: string;
    is_complete?: boolean;
    include_cumulative_score?: boolean;
    include_rating_questions?: boolean | null;
    include_rubric_questions?: boolean | null;
    show_total_on_preview?: boolean | null;
    cumulative_score?: number | null;
    max_cumulative_score?: number | null;
    include_final_recommendation?: boolean;
    include_maybe_option?: boolean | null;
    show_answer_on_preview?: boolean | null;
    final_recommendation?: CoreFinalRecommendationEnum | CoreNullEnum;
    answers: Array<CoreReferenceCheckAnswerWrite>;
    template_name?: string | null;
};

export type CoreReferenceCheckAnswerWrite = {
    readonly id: number;
    question_id: number | null;
    answer_text?: string | null;
    multi_select?: boolean | null;
    mc_answer?: Array<string> | null;
    answer_rating?: number | null;
    answer_rubric?: number | null;
    attachment?: string | null;
};

export type CoreQuestionAnswerTrigger = {
    trigger_type: CoreTriggerTypeEnum;
    question_type: CoreQuestionType4A9Enum;
    question_id: number;
    answer: string;
};

export type CorePrincipalsWorkExperienceOutput = {
    description: string | null;
    do_not_contact: boolean | null;
    end_date: string | null;
    experience_types: Array<number>;
    grades: Array<number>;
    id: number;
    organization: CorePrincipalWorkExperienceOrganization;
    presently_employed: boolean | null;
    reason_for_leaving: string | null;
    reference_email: string | null;
    reference_name: string | null;
    reference_phone: string | null;
    start_date: string | null;
    subjects: Array<number> | null;
    title: string | null;
    years_in_job: number | null;
};

export type CorePrincipalWorkExperienceOrganization = {
    id: number;
    location: string | null;
    name: string | null;
};

export type CorePrincipalsUserOutput = {
    readonly certificates: string;
    candidate_credential_status: string;
    readonly credentials: Array<CorePrincipalCredentialsOutput>;
    education: Array<CorePrincipalsEducationOutput>;
    email: string;
    exams: Array<CorePrincipalsExamOutput>;
    first_name: string;
    id: number;
    last_name: string;
    readonly nimble_answers: string;
    preferences: CorePrincipalsPreferenceOutput;
    previous_positions: Array<CorePrincipalsWorkExperienceOutput>;
    profile: CorePrincipalsProfileOutput;
};

export type CorePrincipalsProfileOutput = {
    readonly resume: string;
    phone_home: string;
    phone_cell: string;
    phone_work: string;
    years_experience: number | null;
    has_no_credentials: boolean;
    address_street?: string | null;
    address_apt?: string | null;
    address_city?: string | null;
    address_state?: string | null;
    address_zip?: string | null;
    languages?: Array<number>;
    district_id?: number | null;
};

export type CorePrincipalsPreferenceOutput = {
    categories: Array<number>;
    employment_type: number | null;
    grades: Array<number>;
    hours_per_week?: string | null;
    location?: string | null;
    miles_within?: string | null;
    multilingual_school: number | null;
    title_1_school: number | null;
    turnaround_school: number | null;
};

export type CorePrincipalsExamOutput = {
    id: number;
    type: number | null;
    praxis_core_reading: number | null;
    praxis_core_writing: number | null;
    praxis_core_math: number | null;
    praxis_plt_score: number | null;
    praxis_subject: number | null;
    praxis_subject_score: number | null;
    sat_new_ebrw: number | null;
    sat_new_math: number | null;
    sat_new_composite: number | null;
    sat_old_reading: number | null;
    sat_old_writing: number | null;
    sat_old_math: number | null;
    sat_old_composite: number | null;
    act_composite: number | null;
    act_english: number | null;
    act_math: number | null;
    act_reading: number | null;
    act_science: number | null;
    gre_composite: number | null;
    gre_verbal: number | null;
    gre_quantitative: number | null;
    gre_writing: number | null;
    cbest_reading: number | null;
    cbest_math: number | null;
    cbest_writing: number | null;
    other_exam_name: string | null;
    other_exam_score: number | null;
    other_exam_possible_score: number | null;
};

export type CorePrincipalsEducationOrganizationOutput = {
    id: number;
    location: string | null;
    name: string;
};

export type CorePrincipalsEducationOutput = {
    id: number;
    degree: number | null;
    end_date: string | null;
    major_enum: number | null;
    school: CorePrincipalsEducationOrganizationOutput | null;
    start_date: string | null;
    university: number | null;
};

export type CorePrincipalCredentialStatusOutput = {
    id: number;
    value: string | null;
    label: string | null;
};

export type CorePrincipalCredentialSubjectOutput = {
    id: number;
    value: string | null;
    label: string | null;
    show_in_connect: boolean;
    show_in_ats: boolean;
    credential_group: string | null;
};

export type CorePrincipalCredentialGradeOutput = {
    id: number;
    value: string | null;
    label: string | null;
};

export type CorePrincipalCredentialsOutput = {
    id: number;
    grade: CorePrincipalCredentialGradeOutput | null;
    subject: CorePrincipalCredentialSubjectOutput | null;
    status: CorePrincipalCredentialStatusOutput | null;
    state: number | null;
    issue_date: string | null;
    certificate: number | null;
    credential_exams_passed: Array<number> | null;
    expiration_date: string | null;
    license_number: string | null;
    verification_status?: string | null;
    readonly verified_on: string;
    readonly screenshot_url: string;
};

export type CorePrincipalsRoleOutput = {
    id: number;
    title: string;
    status: number;
    active_status: number | null;
};

export type CorePrincipalsCandidatesListOutput = {
    id: number;
    role: CorePrincipalsRoleOutput;
    candidate: CorePrincipalsUserOutput;
    candidate_status: CorePrincipalsCandidateStatusOutput | null;
    application: CorePrincipalsApplicationOutput;
    candidate_stage?: string | null;
    readonly has_references: boolean;
};

export type CorePrincipalSchoolPreferencesAnswerOutput = {
    is_interested_in_all: boolean;
    is_open_to_other_options: boolean;
    readonly selected_schools: Array<string>;
};

export type CorePrincipalCustomAnswerOutput = {
    readonly answer: string;
    order: number;
    question?: string;
};

export type CorePrincipalApplicationAttachmentVideoUrlOutput = {
    id: number;
    video_url: string;
    required_application_attachment_id: number;
    title: string;
};

export type CorePrincipalApplicationAttachmentOutput = {
    id: number;
    attachment: string;
    title?: string | null;
    readonly file_size: string;
    readonly file_type: string;
    readonly file_name: string;
};

export type CorePrincipalApplicationQuestionOutput = {
    readonly applicationattachment_set: Array<CorePrincipalApplicationAttachmentOutput>;
    readonly applicationattachmentvideourl_set: Array<CorePrincipalApplicationAttachmentVideoUrlOutput>;
    readonly custom_answers: Array<CorePrincipalCustomAnswerOutput>;
    readonly school_preferences_answer: CorePrincipalSchoolPreferencesAnswerOutput | null;
};

export type CorePrincipalApplicationSourceOutput = {
    id: number;
    label: string;
};

export type CorePrincipalsApplicationOutput = {
    id: number;
    high_retention?: boolean | null;
    source?: CorePrincipalApplicationSourceOutput | null;
    top_candidate?: boolean | null;
    questions: CorePrincipalApplicationQuestionOutput;
};

export type CorePrincipalsCandidateStatusOutput = {
    id: number;
    label: string;
    status_type: number;
    color: number;
};

export type CorePatchedInternalRoleNoteCrud = {
    text?: string;
    readonly created_at?: string | null;
    readonly created_by?: CoreInternalRoleNoteCreatedBy;
    readonly is_edited?: boolean;
    visible_to_all_admin?: boolean;
    readonly id?: number;
    readonly role_id?: number;
    school_role_id?: number;
};

export type CoreInternalRoleNoteCreatedBy = {
    readonly id: number;
    first_name?: string;
    last_name?: string;
};

export type CorePatchedInternalApplicationUpdateRequest = {
    applicant?: unknown;
    custom_questions_and_answers?: unknown | null;
    school_preferences?: unknown | null;
};

export type CorePatchedHiringRequestDetail = {
    readonly id?: number;
    status?: CoreStatusDe3Enum;
};

export type CorePaginatedHiringRequestListList = {
    count: number;
    next?: string;
    previous?: string;
    results: Array<CoreHiringRequestList>;
};

export type CoreHiringRequestCandidateStatusOutput = {
    color: number;
    id: number;
    label: string;
    status_type: number;
};

export type CoreHiringRequestApplicationSourceOutput = {
    id: number;
    label: string;
};

export type CoreHiringRequestSchoolPreferencesAnswerOutput = {
    is_interested_in_all: boolean;
    is_open_to_other_options: boolean;
    readonly selected_schools: string;
};

export type CoreHiringRequestCustomAnswerOutput = {
    readonly answer: string;
    order: number;
    question?: string;
};

export type CoreHiringRequestCandidateApplicationAttachmentVideoUrlOutput = {
    id: number;
    required_application_attachment_id: number;
    title: string;
    video_url: string;
};

export type CoreHiringRequestCandidateApplicationAttachmentOutput = {
    attachment: string;
    readonly file_name: string;
    readonly file_size: string;
    readonly file_type: string;
    id: number;
    title?: string | null;
};

export type CoreHiringRequestApplicationQuestionOutput = {
    readonly applicationattachment_set: Array<CoreHiringRequestCandidateApplicationAttachmentOutput>;
    readonly applicationattachmentvideourl_set: Array<CoreHiringRequestCandidateApplicationAttachmentVideoUrlOutput>;
    readonly custom_answers: Array<CoreHiringRequestCustomAnswerOutput>;
    readonly school_preferences_answer: CoreHiringRequestSchoolPreferencesAnswerOutput | null;
};

export type CoreHiringRequestApplicationOutput = {
    high_retention?: boolean | null;
    id: number;
    questions: CoreHiringRequestApplicationQuestionOutput;
    source?: CoreHiringRequestApplicationSourceOutput | null;
    top_candidate?: boolean | null;
};

export type CoreHiringRequestRequirement = {
    is_reference_required: boolean;
    is_scorecard_required: boolean;
};

export type CoreHiringRequestUser = {
    readonly id: number;
    first_name?: string;
    last_name?: string;
    /**
     * Email address
     */
    email?: string;
};

export type CoreHiringRequestCandidateProfileOutput = {
    district_id?: number | null;
    has_no_credentials: boolean;
    phone_cell: string;
    phone_home: string;
    phone_work: string;
    readonly resume: string;
    years_experience: number | null;
    address_apt?: string | null;
    address_city?: string | null;
    address_state?: string | null;
    address_street?: string | null;
    address_zip?: string | null;
    languages?: Array<number>;
};

export type CoreHiringRequestCandidateWorkExperienceOrganizationOutput = {
    id: number;
    location: string | null;
    name: string | null;
};

export type CoreHiringRequestCandidateWorkExperienceOutput = {
    description: string | null;
    do_not_contact: boolean | null;
    end_date: string | null;
    experience_types: Array<number> | null;
    grades: Array<number> | null;
    id: number;
    organization: CoreHiringRequestCandidateWorkExperienceOrganizationOutput;
    presently_employed: boolean | null;
    reason_for_leaving: string | null;
    reference_email: string | null;
    reference_name: string | null;
    reference_phone: string | null;
    start_date: string | null;
    subjects: Array<number> | null;
    title: string | null;
    years_in_job: number | null;
};

export type CoreHiringRequestCandidatePreferenceOutput = {
    categories: Array<number> | null;
    employment_type: number | null;
    grades: Array<number> | null;
    hours_per_week?: string | null;
    location?: string | null;
    miles_within?: string | null;
    multilingual_school: number | null;
    title_1_school: number | null;
    turnaround_school: number | null;
};

export type CoreHiringRequestCandidateExamOutput = {
    act_composite: number | null;
    act_english: number | null;
    act_math: number | null;
    act_reading: number | null;
    act_science: number | null;
    cbest_math: number | null;
    cbest_reading: number | null;
    cbest_writing: number | null;
    gre_composite: number | null;
    gre_quantitative: number | null;
    gre_verbal: number | null;
    gre_writing: number | null;
    id: number;
    other_exam_name: string | null;
    other_exam_possible_score: number | null;
    other_exam_score: number | null;
    praxis_core_math: number | null;
    praxis_core_reading: number | null;
    praxis_core_writing: number | null;
    praxis_plt_score: number | null;
    praxis_subject: number | null;
    praxis_subject_score: number | null;
    sat_new_composite: number | null;
    sat_new_ebrw: number | null;
    sat_new_math: number | null;
    sat_old_composite: number | null;
    sat_old_math: number | null;
    sat_old_reading: number | null;
    sat_old_writing: number | null;
    type: number | null;
};

export type CoreHiringRequestCandidateEducationOrganizationOutput = {
    id: number;
    location: string | null;
    name: string;
};

export type CoreHiringRequestCandidateEducationOutput = {
    degree: number | null;
    end_date: string | null;
    id: number;
    major_enum: number | null;
    school: CoreHiringRequestCandidateEducationOrganizationOutput | null;
    start_date: string | null;
    university: number | null;
};

export type CoreHiringRequestCandidateCredentialSubjectOutput = {
    credential_group: string | null;
    id: number;
    label: string | null;
    show_in_ats: boolean;
    show_in_connect: boolean;
    value: string | null;
};

export type CoreHiringRequestCandidateCredentialStatusOutput = {
    id: number;
    label: string | null;
    value: string | null;
};

export type CoreHiringRequestCandidateCredentialGradeOutput = {
    id: number;
    label: string | null;
    value: string | null;
};

export type CoreHiringRequestCandidateCredentialsOutput = {
    certificate: number | null;
    credential_exams_passed: Array<number> | null;
    expiration_date: string | null;
    grade: CoreHiringRequestCandidateCredentialGradeOutput | null;
    id: number;
    issue_date: string | null;
    license_number: string | null;
    readonly screenshot_url: string;
    state: number | null;
    status: CoreHiringRequestCandidateCredentialStatusOutput | null;
    subject: CoreHiringRequestCandidateCredentialSubjectOutput | null;
    verification_status?: string | null;
    readonly verified_on: string;
};

export type CoreHiringRequestCandidate = {
    readonly certificates: string;
    readonly candidate_credential_status: string;
    readonly credentials: Array<CoreHiringRequestCandidateCredentialsOutput>;
    education: Array<CoreHiringRequestCandidateEducationOutput>;
    email: string;
    exams: Array<CoreHiringRequestCandidateExamOutput>;
    first_name: string;
    id: number;
    last_name: string;
    readonly nimble_answers: string;
    preferences: CoreHiringRequestCandidatePreferenceOutput;
    previous_positions: Array<CoreHiringRequestCandidateWorkExperienceOutput>;
    profile: CoreHiringRequestCandidateProfileOutput;
};

export type CoreHiringRequestRole = {
    readonly id: number;
    title: string;
    status?: CoreStatus4C5Enum;
    active_status?: CoreActiveStatusEnum | CoreNullEnum;
};

export type CoreHiringRequestList = {
    readonly id: number;
    readonly school_id: number | null;
    role: CoreHiringRequestRole;
    candidate: CoreHiringRequestCandidate;
    requester: CoreHiringRequestUser;
    readonly created: string;
    readonly modified: string;
    readonly notes_count: number;
    readonly has_scorecards: boolean;
    readonly has_references: boolean;
    candidate_info_submitted?: string | null;
    status?: CoreStatusDe3Enum | CoreNullEnum;
    readonly application_id: number;
    readonly requirements: CoreHiringRequestRequirement;
    application: CoreHiringRequestApplicationOutput | null;
    candidate_status?: CoreHiringRequestCandidateStatusOutput | null;
    candidate_stage?: string | null;
};

export type CoreOutput = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
};

export type CoreNotificationData = {
    readonly id: number;
    first_name?: string;
    last_name?: string;
    /**
     * Email address
     */
    email?: string;
    /**
     * Active
     *
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean;
    readonly phone_number: string;
};

/**
 * * `candidate_account_exists` - Candidate Account Exists
 * * `ats_account_exists` - Ats Account Exists
 */
export const CoreInternalUserConflictCodeEnum = { CANDIDATE_ACCOUNT_EXISTS: 'candidate_account_exists', ATS_ACCOUNT_EXISTS: 'ats_account_exists' } as const;

/**
 * * `candidate_account_exists` - Candidate Account Exists
 * * `ats_account_exists` - Ats Account Exists
 */
export type CoreInternalUserConflictCodeEnum = typeof CoreInternalUserConflictCodeEnum[keyof typeof CoreInternalUserConflictCodeEnum];

export type CoreInternalRoleNoteCrud = {
    text: string;
    readonly created_at: string | null;
    readonly created_by: CoreInternalRoleNoteCreatedBy;
    readonly is_edited: boolean;
    visible_to_all_admin?: boolean;
    readonly id: number;
    readonly role_id: number;
    school_role_id?: number;
};

export type CoreInternalExamTypeResult = {
    value: string;
    label: string;
    min: number;
    max: number;
    decimal_places: number;
};

export type CoreInternalExamType = {
    value: string;
    label: string;
    requires_subject: boolean;
    allows_custom_name: boolean;
    allows_max_score: boolean;
    results: Array<CoreInternalExamTypeResult>;
};

export type CoreInternalExamSubject = {
    value: string;
    label: string;
};

export type CoreInternalCredentialStatus = {
    readonly id: number;
    readonly label: string;
};

export type CoreInternalCredentialGrade = {
    readonly id: number;
    readonly label: string;
};

export type CoreInternalCandidateFile = {
    readonly file_id: string;
    readonly name: string;
    readonly url: string;
};

export type CoreInternalCandidateApplicationsResponse = {
    readonly applications: Array<CoreInternalCandidateApplication>;
};

export type CoreInternalCandidateApplication = {
    readonly id: number;
    readonly role_id: number;
    readonly job_title: string;
    readonly district_name: string;
    readonly status: CoreInternalCandidateApplicationStatusEnum;
    readonly updated: string;
};

export type CoreInternalApplicationSection = {
    section: CoreApplicationSectionEnum;
    visible: boolean;
    required: boolean;
};

/**
 * * `resume` - Resume
 * * `education` - Education
 * * `experience` - Experience
 * * `credentials` - Credentials
 * * `languages` - Languages
 * * `exams` - Exams
 * * `certificates` - Certificates
 * * `references` - References
 * * `ssn` - Ssn
 * * `birthdate` - Birthdate
 */
export const CoreApplicationSectionEnum = {
    RESUME: 'resume',
    EDUCATION: 'education',
    EXPERIENCE: 'experience',
    CREDENTIALS: 'credentials',
    LANGUAGES: 'languages',
    EXAMS: 'exams',
    CERTIFICATES: 'certificates',
    REFERENCES: 'references',
    SSN: 'ssn',
    BIRTHDATE: 'birthdate'
} as const;

/**
 * * `resume` - Resume
 * * `education` - Education
 * * `experience` - Experience
 * * `credentials` - Credentials
 * * `languages` - Languages
 * * `exams` - Exams
 * * `certificates` - Certificates
 * * `references` - References
 * * `ssn` - Ssn
 * * `birthdate` - Birthdate
 */
export type CoreApplicationSectionEnum = typeof CoreApplicationSectionEnum[keyof typeof CoreApplicationSectionEnum];

export type CoreInternalApplicationCreateRequest = {
    role_id: number;
};

export type CoreInternalApplication = {
    readonly application: CoreApplicationSummary;
    readonly applicant: CoreApplicationApplicant;
    readonly resume: CoreApplicationResume | null;
    readonly education: Array<CoreApplicationEducation>;
    readonly experience: Array<CoreApplicationExperience>;
    readonly credentials: Array<CoreApplicationCredential>;
    readonly exams: Array<CoreApplicationExam>;
    readonly languages: Array<CoreApplicationLanguage>;
    readonly references: Array<CoreApplicationReference>;
    readonly certificates: Array<CoreApplicationCertificate>;
    readonly custom_questions_and_answers: Array<CoreApplicationAnswer>;
    readonly school_preferences: CoreApplicationSchoolPreferences | null;
};

export type CoreInput = {
    email: string;
    first_name: string;
    last_name: string;
};

export type CoreImpersonationAcquireRequest = {
    user_pk: number;
};

export type CoreHiringRequestPostResponseBody = {
    candidate_id: number;
    hiring_request_id: number;
};

export type CoreHiringRequestPostRequestBody = {
    candidate_id: number;
    role_id: number;
    contact_methods: Array<string>;
    internal_candidate_note_content?: string;
    school_id?: number;
};

export type CoreHiringRequestDetail = {
    readonly id: number;
    status: CoreStatusDe3Enum;
};

export type CoreHrbpAssignment = {
    readonly id: number;
    readonly admin_users: Array<string>;
    readonly schools: Array<string>;
};

export type CoreDistrictUsersResponse = {
    nces_not_present: boolean;
    readonly users: Array<CoreDistrictUser>;
};

export type CoreDistrictUser = {
    readonly id: number;
    first_name?: string;
    last_name?: string;
    /**
     * Email address
     */
    email?: string;
    readonly user_type: CoreUserTypeEnum;
};

export type CoreDistrictReferenceList = {
    readonly id: number;
    name?: string;
    email?: string;
};

export type CoreCredentialWithVerification = {
    readonly id: number;
    readonly grade: string;
    readonly subject: string;
    readonly status: string;
    readonly state: string;
    issue_date?: string | null;
    certificate?: CoreCertificateEnum | CoreNullEnum;
    credential_exams_passed?: Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34 | 35 | 36> | null;
    expiration_date?: string | null;
    license_number?: string | null;
    credential_explanation?: string | null;
    credential_provided_license_id?: string | null;
    credential_provided_name?: string | null;
    credential_provided_proof_img?: string | null;
    readonly verification_status: string;
    readonly screenshot_url: string | null;
    readonly verified_on: string | null;
};

/**
 * * `Deprecated` - Deprecated
 * * `Yes` - Yes
 * * `No Other State` - No Other State
 * * `No Finishing` - No Finishing
 * * `No Submitted` - No Submitted
 * * `No` - No
 */
export const CoreCertificateEnum = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * * `Deprecated` - Deprecated
 * * `Yes` - Yes
 * * `No Other State` - No Other State
 * * `No Finishing` - No Finishing
 * * `No Submitted` - No Submitted
 * * `No` - No
 */
export type CoreCertificateEnum = typeof CoreCertificateEnum[keyof typeof CoreCertificateEnum];

export type CoreConflict = {
    code: CoreInternalUserConflictCodeEnum;
};

export type CoreCohireHijackAuthorizationRequest = {
    actor_id: number;
    target_id: number;
};

export type CoreBulkAutomationResponse = {
    order: number;
    trigger: CoreAutomationTrigger;
    action: CoreAutomationAction;
    id: number;
};

export type CoreAutomationAction = ({
    action_type: 'core_UpdateStatusAction';
} & CoreUpdateStatusAction) | ({
    action_type: 'core_SendReferenceCheckAction';
} & CoreSendReferenceCheckAction);

export type CoreAutomationTrigger = ({
    trigger_type: 'core_QuestionAnswerTrigger';
} & CoreQuestionAnswerTrigger) | ({
    trigger_type: 'core_UpdateStatusTrigger';
} & CoreUpdateStatusTrigger);

export type CoreAutomationList = {
    id: number;
    order: number;
    trigger: CoreAutomationTrigger;
    action: CoreAutomationAction;
};

export type CoreAutomation = {
    order: number;
    trigger: CoreAutomationTrigger;
    action: CoreAutomationAction;
};

export type CoreGradesNumbers = Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13>;

export const MilesWithin = {
    5: '5',
    10: '10',
    25: '25',
    50: '50',
    75: '75',
    100: '100'
} as const;

export type MilesWithin = typeof MilesWithin[keyof typeof MilesWithin];

export const ConnectCandidateTier = {
    TIER_1: 'tier_1',
    TIER_2: 'tier_2',
    NONE: 'none'
} as const;

export type ConnectCandidateTier = typeof ConnectCandidateTier[keyof typeof ConnectCandidateTier];

export const OnboardingStatus = {
    ACTIVE: 'active',
    ACTIVE_DORMANT: 'active_dormant',
    INACTIVE: 'inactive',
    PENDING_APPROVAL: 'pending_approval'
} as const;

export type OnboardingStatus = typeof OnboardingStatus[keyof typeof OnboardingStatus];

export const EducationOrganizationType = { DEFAULT: 'default' } as const;

export type EducationOrganizationType = typeof EducationOrganizationType[keyof typeof EducationOrganizationType];

export type Grade = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;

export type Degree = -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const CredentialEligibilityStatus = { OPEN_TO_EMERGENCY_CREDENTIALS: 'open_to_emergency_credentials', CLOSED_TO_EMERGENCY_CREDENTIALS: 'closed_to_emergency_credentials' } as const;

export type CredentialEligibilityStatus = typeof CredentialEligibilityStatus[keyof typeof CredentialEligibilityStatus];

export const YearsOfTeachingExperience = {
    ONE_TO_TWO_YEARS: 'one_to_two_years',
    THREE_TO_FIVE_YEARS: 'three_to_five_years',
    SIX_TO_NINE_YEARS: 'six_to_nine_years',
    TEN_PLUS_YEARS: 'ten_plus_years',
    SUBSTITUTE_PART_TIME_AIDE: 'substitute_part_time_aide',
    NO_TEACHING_EXPERIENCE: 'no_teaching_experience'
} as const;

export type YearsOfTeachingExperience = typeof YearsOfTeachingExperience[keyof typeof YearsOfTeachingExperience];

export const CredentialSubjectGroup = { TEACHING: 'teaching' } as const;

export type CredentialSubjectGroup = typeof CredentialSubjectGroup[keyof typeof CredentialSubjectGroup];

export const ResumeVerificationStatus = {
    FAILED_MANUAL_VERIFICATION: 'failed_manual_verification',
    MANUALLY_VERIFIED: 'manually_verified',
    PENDING_MANUAL_VERIFICATION: 'pending_manual_verification'
} as const;

export type ResumeVerificationStatus = typeof ResumeVerificationStatus[keyof typeof ResumeVerificationStatus];

export const CredentialVerificationStatus = {
    INELIGIBLE_FOR_STATE_VERIFICATION: 'ineligible_for_state_verification',
    PENDING_MANUAL_VERIFICATION: 'pending_manual_verification',
    FAILED_VERIFICATION: 'failed_verification',
    PASSED_MANUAL_VERIFICATION_PENDING: 'passed_manual_verification_pending',
    PASSED_AUTO_VERIFICATION: 'passed_auto_verification',
    PENDING_AUTO_VERIFICATION: 'pending_auto_verification',
    PASSED_MANUAL_VERIFICATION: 'passed_manual_verification',
    FAILED_AUTO_VERIFICATION: 'failed_auto_verification'
} as const;

export type CredentialVerificationStatus = typeof CredentialVerificationStatus[keyof typeof CredentialVerificationStatus];

export const AtsTier = {
    POSTING_ONLY: 'posting_only',
    ATS_LITE: 'ats_lite',
    ATS_FULL: 'ats_full'
} as const;

export type AtsTier = typeof AtsTier[keyof typeof AtsTier];

export const CandidateApplicationStatus = {
    DRAFT: 'draft',
    DRAFT_NOT_SUBMITTABLE: 'draft_not_submittable',
    SUBMITTED: 'submitted'
} as const;

export type CandidateApplicationStatus = typeof CandidateApplicationStatus[keyof typeof CandidateApplicationStatus];

export const JobSeekingStatus = {
    OPEN_TO_WORK_AND_MATCHES: 'open_to_work_and_matches',
    OPEN_TO_WORK: 'open_to_work',
    CLOSED_TO_WORK: 'closed_to_work'
} as const;

export type JobSeekingStatus = typeof JobSeekingStatus[keyof typeof JobSeekingStatus];

export type CoreApplicationExamWritable = {
    exam: string;
    subject: string | null;
    custom_name: string | null;
    results: Array<CoreApplicationExamResult>;
};

export type CoreStatusWritable = {
    label: string;
};

export type CoreScorecardWriteWritable = {
    custom_scorecard_id: number;
    scorecard_complete?: boolean;
    include_cumulative_score?: boolean;
    include_rating_questions?: boolean | null;
    include_rubric_questions?: boolean | null;
    show_total_on_preview?: boolean | null;
    cumulative_score?: number | null;
    max_cumulative_score?: number | null;
    include_final_recommendation?: boolean;
    include_maybe_option?: boolean | null;
    show_answer_on_preview?: boolean | null;
    final_recommendation?: CoreFinalRecommendationEnum | CoreNullEnum;
    answers: Array<CoreScorecardAnswerCreateWritable>;
};

export type CoreScorecardAnswerCreateWritable = {
    question_id: number;
    answer_text?: string | null;
    multi_select?: boolean | null;
    mc_answer?: Array<string> | null;
    answer_rubric?: number | null;
    answer_rating?: number | null;
    attachment?: string | null;
};

export type CoreScorecardQuestionWritable = {
    question_text?: string;
    is_required?: boolean;
    mc_options?: Array<string> | null;
    scale?: number | null;
    rubric_columns?: unknown | null;
    multi_select?: boolean | null;
    show_total_on_preview?: boolean | null;
    include_maybe_option?: boolean | null;
    directions?: string | null;
};

export type CoreScorecardListWritable = {
    hiring_request_id: number;
    scorecard_complete?: boolean;
    include_cumulative_score?: boolean;
    include_rating_questions?: boolean | null;
    include_rubric_questions?: boolean | null;
    show_total_on_preview?: boolean | null;
    cumulative_score?: number | null;
    max_cumulative_score?: number | null;
    include_final_recommendation?: boolean;
    include_maybe_option?: boolean | null;
    show_answer_on_preview?: boolean | null;
    answers: Array<CoreScorecardAnswerWritable>;
    is_universal?: boolean;
};

export type CoreScorecardAnswerWritable = {
    is_required?: boolean;
    question: CoreScorecardQuestionWritable;
    answer_text?: string | null;
    multi_select?: boolean | null;
    mc_answer?: Array<string> | null;
    answer_rubric?: number | null;
    answer_rating?: number | null;
};

export type CoreSchoolRoleVacancyWritable = {
    school_id: number;
    ftes_total?: number | null;
    school_name: string;
    visible_to_school_admin?: boolean;
};

export type CoreSchoolPreferencesQuestionWritable = {
    id?: number;
    question_set?: number | null;
    is_automatic_list: boolean;
    school_choices: Array<number>;
    order?: number;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    included_in_preview?: boolean;
};

export type CoreRoleVacancyWritable = {
    district_ftes_total: number;
};

export type CoreRoleSettingsWritable = {
    internal_only: boolean;
    external_date?: string | null;
    requisition_number?: string | null;
    internal_requirements_specified: boolean;
};

export type CoreRoleSectionWritable = {
    visible?: boolean;
    required?: boolean;
    visible_internal?: boolean;
    required_internal?: boolean;
};

export type CoreRoleQuestionsWritable = {
    question_sets_order: Array<CoreQuestionSetOrder>;
};

export type CoreQuestionSetWritable = {
    uuid?: string;
    title: string;
    roles?: Array<number>;
    id?: number;
    requiredapplicationattachment_set?: Array<CoreRequiredApplicationAttachment>;
    custom_questions?: Array<CoreCustomQuestionSerializerWithTagsWritable>;
    nimble_rolequestion_set?: Array<CoreNimbleRoleQuestionWritable>;
    school_preferences_question?: Array<CoreSchoolPreferencesQuestionWritable> | null;
};

/**
 * Serializer for NimbleQuestions <> Role/SchoolRole through relationship.
 */
export type CoreNimbleRoleQuestionWritable = {
    id?: number;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    nimblequestion_id: number;
    order: number;
    included_in_preview?: boolean;
};

export type CoreCustomQuestionSerializerWithTagsWritable = {
    role?: number | null;
    id?: number;
    prompt: string;
    is_legal?: boolean;
    is_district_default?: boolean;
    question_type: CoreQuestionType4A9Enum;
    hint?: string;
    mc_options?: Array<string> | null;
    multi_select?: boolean | null;
    is_visible_external?: boolean;
    is_required_external?: boolean;
    is_visible_internal?: boolean;
    is_required_internal?: boolean;
    order?: number;
    included_in_preview?: boolean;
    autotags?: Array<CoreQuestionAutoTag> | null;
};

export type CoreRoleOverviewDistrictWritable = {
    name: string;
};

export type CoreRoleOverviewWritable = {
    title: string;
    district: CoreRoleOverviewDistrictWritable;
    status: number;
    active_status: number;
};

export type CoreRoleDetailsSchoolWritable = {
    name: string;
    location?: string;
};

export type CoreRoleDetailsWritable = {
    title: string;
    description?: string | null;
    benefits?: string | null;
    requirements_text?: string;
    date_posted?: string | null;
    status?: CoreStatus4C5Enum;
    hiring_season?: CoreHiringSeasonEnum;
    grades?: Array<CoreGradesEnum>;
    languages?: Array<-1 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 18 | 19 | 20 | 21 | 999> | null;
    deadline?: string | null;
    salary_min?: number | null;
    salary_max?: number | null;
    salary_type?: CoreSalaryTypeEnum | CoreNullEnum;
    start_date?: string | null;
    start_date_type?: CoreStartDateTypeEnum;
    end_date?: string | null;
    fulltime?: number | null;
    is_template?: boolean;
    contact?: string;
    active_status?: CoreActiveStatusEnum | CoreNullEnum;
    district_id: number;
};

export type CoreRoleActivityFeedWritable = {
    id: number;
    verb: string;
    published: string;
};

export type CoreReferenceCheckWriteWritable = {
    candidate_id?: number;
    reference_id?: number;
    reference_template_id?: number;
    submitted_by_name?: string | null;
    submitted_by_title?: string | null;
    is_complete?: boolean;
    include_cumulative_score?: boolean;
    include_rating_questions?: boolean | null;
    include_rubric_questions?: boolean | null;
    show_total_on_preview?: boolean | null;
    cumulative_score?: number | null;
    max_cumulative_score?: number | null;
    include_final_recommendation?: boolean;
    include_maybe_option?: boolean | null;
    show_answer_on_preview?: boolean | null;
    final_recommendation?: CoreFinalRecommendationEnum | CoreNullEnum;
    answers: Array<CoreReferenceCheckAnswerWriteWritable>;
    template_name?: string | null;
};

export type CoreReferenceCheckAnswerWriteWritable = {
    question_id: number | null;
    answer_text?: string | null;
    multi_select?: boolean | null;
    mc_answer?: Array<string> | null;
    answer_rating?: number | null;
    answer_rubric?: number | null;
    attachment?: string | null;
};

export type CorePrincipalsUserOutputWritable = {
    candidate_credential_status: string;
    education: Array<CorePrincipalsEducationOutput>;
    email: string;
    exams: Array<CorePrincipalsExamOutput>;
    first_name: string;
    id: number;
    last_name: string;
    preferences: CorePrincipalsPreferenceOutput;
    previous_positions: Array<CorePrincipalsWorkExperienceOutput>;
    profile: CorePrincipalsProfileOutputWritable;
};

export type CorePrincipalsProfileOutputWritable = {
    phone_home: string;
    phone_cell: string;
    phone_work: string;
    years_experience: number | null;
    has_no_credentials: boolean;
    address_street?: string | null;
    address_apt?: string | null;
    address_city?: string | null;
    address_state?: string | null;
    address_zip?: string | null;
    languages?: Array<number>;
    district_id?: number | null;
};

export type CorePrincipalCredentialsOutputWritable = {
    id: number;
    grade: CorePrincipalCredentialGradeOutput | null;
    subject: CorePrincipalCredentialSubjectOutput | null;
    status: CorePrincipalCredentialStatusOutput | null;
    state: number | null;
    issue_date: string | null;
    certificate: number | null;
    credential_exams_passed: Array<number> | null;
    expiration_date: string | null;
    license_number: string | null;
    verification_status?: string | null;
};

export type CorePrincipalsCandidatesListOutputWritable = {
    id: number;
    role: CorePrincipalsRoleOutput;
    candidate: CorePrincipalsUserOutputWritable;
    candidate_status: CorePrincipalsCandidateStatusOutput | null;
    application: CorePrincipalsApplicationOutputWritable;
    candidate_stage?: string | null;
};

export type CorePrincipalSchoolPreferencesAnswerOutputWritable = {
    is_interested_in_all: boolean;
    is_open_to_other_options: boolean;
};

export type CorePrincipalCustomAnswerOutputWritable = {
    order: number;
    question?: string;
};

export type CorePrincipalApplicationAttachmentOutputWritable = {
    id: number;
    attachment: string;
    title?: string | null;
};

export type CorePrincipalApplicationQuestionOutputWritable = {
    [key: string]: unknown;
};

export type CorePrincipalsApplicationOutputWritable = {
    id: number;
    high_retention?: boolean | null;
    source?: CorePrincipalApplicationSourceOutput | null;
    top_candidate?: boolean | null;
    questions: CorePrincipalApplicationQuestionOutputWritable;
};

export type CorePatchedInternalRoleNoteCrudWritable = {
    text?: string;
    visible_to_all_admin?: boolean;
    school_role_id?: number;
    tagged_users?: Array<number>;
};

export type CoreInternalRoleNoteCreatedByWritable = {
    first_name?: string;
    last_name?: string;
};

export type CorePaginatedHiringRequestListListWritable = {
    count: number;
    next?: string;
    previous?: string;
    results: Array<CoreHiringRequestListWritable>;
};

export type CoreHiringRequestSchoolPreferencesAnswerOutputWritable = {
    is_interested_in_all: boolean;
    is_open_to_other_options: boolean;
};

export type CoreHiringRequestCustomAnswerOutputWritable = {
    order: number;
    question?: string;
};

export type CoreHiringRequestCandidateApplicationAttachmentOutputWritable = {
    attachment: string;
    id: number;
    title?: string | null;
};

export type CoreHiringRequestApplicationQuestionOutputWritable = {
    [key: string]: unknown;
};

export type CoreHiringRequestApplicationOutputWritable = {
    high_retention?: boolean | null;
    id: number;
    questions: CoreHiringRequestApplicationQuestionOutputWritable;
    source?: CoreHiringRequestApplicationSourceOutput | null;
    top_candidate?: boolean | null;
};

export type CoreHiringRequestUserWritable = {
    first_name?: string;
    last_name?: string;
    /**
     * Email address
     */
    email?: string;
};

export type CoreHiringRequestCandidateProfileOutputWritable = {
    district_id?: number | null;
    has_no_credentials: boolean;
    phone_cell: string;
    phone_home: string;
    phone_work: string;
    years_experience: number | null;
    address_apt?: string | null;
    address_city?: string | null;
    address_state?: string | null;
    address_street?: string | null;
    address_zip?: string | null;
    languages?: Array<number>;
};

export type CoreHiringRequestCandidateCredentialsOutputWritable = {
    certificate: number | null;
    credential_exams_passed: Array<number> | null;
    expiration_date: string | null;
    grade: CoreHiringRequestCandidateCredentialGradeOutput | null;
    id: number;
    issue_date: string | null;
    license_number: string | null;
    state: number | null;
    status: CoreHiringRequestCandidateCredentialStatusOutput | null;
    subject: CoreHiringRequestCandidateCredentialSubjectOutput | null;
    verification_status?: string | null;
};

export type CoreHiringRequestCandidateWritable = {
    education: Array<CoreHiringRequestCandidateEducationOutput>;
    email: string;
    exams: Array<CoreHiringRequestCandidateExamOutput>;
    first_name: string;
    id: number;
    last_name: string;
    preferences: CoreHiringRequestCandidatePreferenceOutput;
    previous_positions: Array<CoreHiringRequestCandidateWorkExperienceOutput>;
    profile: CoreHiringRequestCandidateProfileOutputWritable;
};

export type CoreHiringRequestRoleWritable = {
    title: string;
    status?: CoreStatus4C5Enum;
    active_status?: CoreActiveStatusEnum | CoreNullEnum;
};

export type CoreHiringRequestListWritable = {
    role: CoreHiringRequestRoleWritable;
    candidate: CoreHiringRequestCandidateWritable;
    requester: CoreHiringRequestUserWritable;
    candidate_info_submitted?: string | null;
    status?: CoreStatusDe3Enum | CoreNullEnum;
    application: CoreHiringRequestApplicationOutputWritable | null;
    candidate_status?: CoreHiringRequestCandidateStatusOutput | null;
    candidate_stage?: string | null;
};

export type CoreNotificationDataWritable = {
    first_name?: string;
    last_name?: string;
    /**
     * Email address
     */
    email?: string;
    /**
     * Active
     *
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean;
};

export type CoreInternalRoleNoteCrudWritable = {
    text: string;
    visible_to_all_admin?: boolean;
    school_role_id?: number;
    tagged_users?: Array<number>;
};

export type CoreInternalApplicationWritable = {
    [key: string]: unknown;
};

export type CoreDistrictUsersResponseWritable = {
    nces_not_present: boolean;
};

export type CoreDistrictUserWritable = {
    first_name?: string;
    last_name?: string;
    /**
     * Email address
     */
    email?: string;
};

export type CoreDistrictReferenceListWritable = {
    name?: string;
    email?: string;
};

export type CoreCredentialWithVerificationWritable = {
    issue_date?: string | null;
    certificate?: CoreCertificateEnum | CoreNullEnum;
    credential_exams_passed?: Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34 | 35 | 36> | null;
    expiration_date?: string | null;
    license_number?: string | null;
    credential_explanation?: string | null;
    credential_provided_license_id?: string | null;
    credential_provided_name?: string | null;
    credential_provided_proof_img?: string | null;
};

export type GetApiAuthDiscoverAuthUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/discover_auth_user/';
};

export type GetApiAuthDiscoverAuthUserResponses = {
    200: {
        id: number;
        email: string;
        name: string;
        first_name: string;
        last_name: string;
        date_joined: string;
        last_login: string | null;
        intercom_hmac: string;
        is_hijacked?: boolean;
        preference: {
            job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work' | null;
        } | null;
        profile: {
            user_type: number;
            address_city: string;
            address_state: string;
            district: {
                id: number;
                name: string;
                parent_organization: string | null;
            } | null;
        } | null;
    } | {
        [key: string]: never;
    };
};

export type GetApiAuthDiscoverAuthUserResponse = GetApiAuthDiscoverAuthUserResponses[keyof GetApiAuthDiscoverAuthUserResponses];

export type DeleteApiAuthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/';
};

export type DeleteApiAuthResponses = {
    /**
     * Logout successful
     */
    200: {
        [key: string]: unknown;
    };
};

export type DeleteApiAuthResponse = DeleteApiAuthResponses[keyof DeleteApiAuthResponses];

export type PostApiAuthData = {
    body?: {
        username: string;
        password: string;
    };
    path?: never;
    query?: never;
    url: '/api/auth/';
};

export type PostApiAuthErrors = {
    /**
     * Authentication failed
     */
    401: {
        message: string;
    };
};

export type PostApiAuthError = PostApiAuthErrors[keyof PostApiAuthErrors];

export type PostApiAuthResponses = {
    /**
     * Authentication successful
     */
    200: {
        id: number;
        email: string;
        name: string;
        first_name: string;
        last_name: string;
        date_joined: string;
        last_login: string | null;
        intercom_hmac: string;
        is_hijacked?: boolean;
        preference: {
            job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work' | null;
            geocoded_location: string | null;
            miles_within: string | null;
            nimble_connect_profile?: {
                form_completion_statuses?: {
                    profile_form?: boolean;
                    resume_and_credentials_form?: boolean;
                    preference_form?: boolean;
                };
            };
        } | null;
        profile: {
            user_type: number;
            address_city: string;
            address_state: string;
            connect_first_profile_setup?: string | null;
            district: {
                id: number;
                name: string;
                parent_organization: string | null;
            } | null;
        } | null;
    } | {
        [key: string]: never;
    };
};

export type PostApiAuthResponse = PostApiAuthResponses[keyof PostApiAuthResponses];

export type PostApiAuthGoogleLoginData = {
    body?: {
        google_token: string;
        nimble_product?: string;
        signup_action?: string;
        redirect_to?: string;
        state?: string;
        mode?: 'login_or_signup' | 'login_only';
    };
    path?: never;
    query?: never;
    url: '/api/auth/google_login/';
};

export type PostApiAuthGoogleLoginErrors = {
    /**
     * Authentication failed
     */
    401: {
        message: string;
    };
};

export type PostApiAuthGoogleLoginError = PostApiAuthGoogleLoginErrors[keyof PostApiAuthGoogleLoginErrors];

export type PostApiAuthGoogleLoginResponses = {
    /**
     * Google authentication successful
     */
    200: {
        id: number;
        email: string;
        name: string;
        first_name: string;
        last_name: string;
        date_joined: string;
        last_login: string | null;
        intercom_hmac: string;
        is_hijacked?: boolean;
        preference: {
            job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work' | null;
            geocoded_location: string | null;
            miles_within: string | null;
            nimble_connect_profile?: {
                form_completion_statuses?: {
                    profile_form?: boolean;
                    resume_and_credentials_form?: boolean;
                    preference_form?: boolean;
                };
            };
        } | null;
        profile: {
            user_type: number;
            address_city: string;
            address_state: string;
            connect_first_profile_setup?: string | null;
            district: {
                id: number;
                name: string;
                parent_organization: string | null;
            } | null;
        } | null;
    } | {
        [key: string]: never;
    };
};

export type PostApiAuthGoogleLoginResponse = PostApiAuthGoogleLoginResponses[keyof PostApiAuthGoogleLoginResponses];

export type PostApiAuthRegisterPasswordlessData = {
    body?: {
        email: string;
        agree_tos: boolean;
        signup_data?: {
            [key: string]: unknown;
        };
        signup_action?: string;
    };
    path?: never;
    query?: never;
    url: '/api/auth/register/passwordless/';
};

export type PostApiAuthRegisterPasswordlessErrors = {
    /**
     * Bad request - validation errors
     */
    400: {
        errors: {
            [key: string]: Array<string>;
        };
    };
    /**
     * Conflict - user already exists
     */
    409: {
        error: string;
        retry_after?: number;
    };
};

export type PostApiAuthRegisterPasswordlessError = PostApiAuthRegisterPasswordlessErrors[keyof PostApiAuthRegisterPasswordlessErrors];

export type PostApiAuthRegisterPasswordlessResponses = {
    /**
     * Passwordless registration successful - user signed up
     */
    201: unknown;
};

export type PostApiAuthOtpRequestData = {
    body?: {
        email: string;
    };
    path?: never;
    query?: never;
    url: '/api/auth/otp/request/';
};

export type PostApiAuthOtpRequestErrors = {
    /**
     * Bad request - validation errors
     */
    400: {
        error: string;
        retry_after?: number;
    };
    /**
     * Too many requests - rate limited
     */
    429: {
        error: string;
        retry_after?: number;
    };
    /**
     * Server error - failed to send OTP
     */
    500: {
        error: string;
        retry_after?: number;
    };
};

export type PostApiAuthOtpRequestError = PostApiAuthOtpRequestErrors[keyof PostApiAuthOtpRequestErrors];

export type PostApiAuthOtpRequestResponses = {
    /**
     * OTP request successful - code sent via email
     */
    200: {
        message: string;
        user_id: number;
    };
};

export type PostApiAuthOtpRequestResponse = PostApiAuthOtpRequestResponses[keyof PostApiAuthOtpRequestResponses];

export type PostApiAuthOtpVerifyData = {
    body?: {
        email: string;
        token: string;
    };
    path?: never;
    query?: never;
    url: '/api/auth/otp/verify/';
};

export type PostApiAuthOtpVerifyErrors = {
    /**
     * Bad request - validation errors
     */
    400: {
        error: string;
        retry_after?: number;
    };
    /**
     * Authentication failed - invalid or expired token
     */
    401: {
        error: string;
        retry_after?: number;
    };
};

export type PostApiAuthOtpVerifyError = PostApiAuthOtpVerifyErrors[keyof PostApiAuthOtpVerifyErrors];

export type PostApiAuthOtpVerifyResponses = {
    /**
     * OTP verification successful - user authenticated
     */
    200: {
        message: string;
        user_id: number;
        email: string;
    };
};

export type PostApiAuthOtpVerifyResponse = PostApiAuthOtpVerifyResponses[keyof PostApiAuthOtpVerifyResponses];

export type GetApiInternalConnectExportCoreDataData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/internal/connect/export_core_data/';
};

export type GetApiInternalConnectExportCoreDataResponses = {
    200: {
        internal_school_nces_ids: {
            [key: string]: number;
        };
        school_nces_ids_by_district_nces_id: {
            [key: string]: Array<string>;
        };
        principals_by_school: {
            [key: string]: {
                id: number;
                first_name: string;
                last_name: string;
                on_connect: boolean;
            };
        };
        tags: {
            [key: string]: {
                name: string;
                tooltip_text: string;
                icon: 'star' | 'money' | 'people' | 'rocket' | 'local_shipping' | 'work' | 'time' | 'sports' | 'redeem' | 'favorite' | 'location' | 'chat' | 'music' | 'file' | 'settings' | 'shield' | 'sell' | 'bolt' | 'calendar';
                display_at: Array<'school_match_cards' | 'more_info_slider' | 'school_detail_section'>;
            };
        };
        tags_by_school: {
            [key: string]: Array<number>;
        };
        districts_data: {
            [key: string]: {
                tier: 'posting_only' | 'ats_lite' | 'ats_full';
            };
        };
    };
};

export type GetApiInternalConnectExportCoreDataResponse = GetApiInternalConnectExportCoreDataResponses[keyof GetApiInternalConnectExportCoreDataResponses];

export type PostApiInternalConnectCandidatesCardsData = {
    body?: {
        candidate_ids: Array<number>;
    };
    path?: never;
    query?: never;
    url: '/api/internal/connect/candidates/cards/';
};

export type PostApiInternalConnectCandidatesCardsResponses = {
    /**
     * Bulk candidate card data
     */
    200: {
        candidates: Array<{
            id: number;
            first_name: string;
            last_name: string;
            email: string;
            is_active?: boolean;
            years_of_teaching_experience: 'one_to_two_years' | 'three_to_five_years' | 'six_to_nine_years' | 'ten_plus_years' | 'substitute_part_time_aide' | 'no_teaching_experience';
            phone: string | null;
            credentials: Array<{
                subject_label: string | null;
                subject_value: string | null;
                grade: string | null;
            }>;
            education: Array<{
                major: string;
                school: string | null;
                degree: string | null;
            }>;
            preference: {
                grades: Array<number>;
                subjects: Array<string>;
                location: string;
                miles_within: string;
                job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work';
            };
        }>;
    };
};

export type PostApiInternalConnectCandidatesCardsResponse = PostApiInternalConnectCandidatesCardsResponses[keyof PostApiInternalConnectCandidatesCardsResponses];

export type GetApiInternalConnectSchoolBySchoolNcesIdPrincipalData = {
    body?: never;
    path: {
        school_nces_id: string;
    };
    query?: never;
    url: '/api/internal/connect/school/{school_nces_id}/principal/';
};

export type GetApiInternalConnectSchoolBySchoolNcesIdPrincipalResponses = {
    /**
     * School principal information
     */
    200: {
        id: number;
        school_nces_id: string;
        first_name: string;
        last_name: string;
        on_connect: boolean;
        email: string | null;
        phone_number: string | null;
        cell_phone_number: string | null;
        school_calendar_link: string | null;
        school_fully_staffed: string | null;
        school_open_roles_grades: Array<number> | null;
        school_open_roles_subjects: Array<string> | null;
        school_open_to_emergency_credentials: string | null;
        custom_response_message: string | null;
        last_preferences_updated_by: 'principal' | 'district_admin' | null;
        district_is_active: boolean | null;
        district_tier: 'posting_only' | 'ats_lite' | 'ats_full';
        onboarding_status: 'active' | 'active_dormant' | 'inactive' | 'pending_approval';
    };
};

export type GetApiInternalConnectSchoolBySchoolNcesIdPrincipalResponse = GetApiInternalConnectSchoolBySchoolNcesIdPrincipalResponses[keyof GetApiInternalConnectSchoolBySchoolNcesIdPrincipalResponses];

export type PostApiInternalConnectSchoolBySchoolNcesIdPrincipalData = {
    body?: {
        id?: number;
        school_nces_id?: string;
        first_name?: string;
        last_name?: string;
        on_connect?: boolean;
        email?: string | null;
        phone_number?: string | null;
        cell_phone_number?: string | null;
        school_calendar_link?: string | null;
        school_fully_staffed?: string | null;
        school_open_roles_grades?: Array<number> | null;
        school_open_roles_subjects?: Array<string> | null;
        school_open_to_emergency_credentials?: string | null;
        custom_response_message?: string | null;
        last_preferences_updated_by?: 'principal' | 'district_admin' | null;
        district_is_active?: boolean | null;
        district_tier?: 'posting_only' | 'ats_lite' | 'ats_full';
        onboarding_status?: 'active' | 'active_dormant' | 'inactive' | 'pending_approval';
    };
    path: {
        school_nces_id: string;
    };
    query?: never;
    url: '/api/internal/connect/school/{school_nces_id}/principal/';
};

export type PostApiInternalConnectSchoolBySchoolNcesIdPrincipalResponses = {
    /**
     * Updated school principal information
     */
    200: {
        id: number;
        school_nces_id: string;
        first_name: string;
        last_name: string;
        on_connect: boolean;
        email: string | null;
        phone_number: string | null;
        cell_phone_number: string | null;
        school_calendar_link: string | null;
        school_fully_staffed: string | null;
        school_open_roles_grades: Array<number> | null;
        school_open_roles_subjects: Array<string> | null;
        school_open_to_emergency_credentials: string | null;
        custom_response_message: string | null;
        last_preferences_updated_by: 'principal' | 'district_admin' | null;
        district_is_active: boolean | null;
        district_tier: 'posting_only' | 'ats_lite' | 'ats_full';
        onboarding_status: 'active' | 'active_dormant' | 'inactive' | 'pending_approval';
    };
};

export type PostApiInternalConnectSchoolBySchoolNcesIdPrincipalResponse = PostApiInternalConnectSchoolBySchoolNcesIdPrincipalResponses[keyof PostApiInternalConnectSchoolBySchoolNcesIdPrincipalResponses];

export type PostApiInternalConnectSchoolSignupData = {
    body?: {
        school_nces_id: string;
        first_name: string;
        last_name: string;
        email?: string | null;
        phone_number?: string | null;
        cell_phone_number?: string | null;
        school_open_roles_grades?: Array<number> | null;
        school_open_roles_subjects?: Array<string> | null;
        school_open_to_emergency_credentials?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/internal/connect/school/signup/';
};

export type PostApiInternalConnectSchoolSignupErrors = {
    /**
     * School already signed up (active or pending approval)
     */
    409: {
        detail: string;
    };
};

export type PostApiInternalConnectSchoolSignupError = PostApiInternalConnectSchoolSignupErrors[keyof PostApiInternalConnectSchoolSignupErrors];

export type PostApiInternalConnectSchoolSignupResponses = {
    /**
     * Updated existing (inactive) school principal information
     */
    200: {
        id: number;
        school_nces_id: string;
        first_name: string;
        last_name: string;
        on_connect: boolean;
        email: string | null;
        phone_number: string | null;
        cell_phone_number: string | null;
        school_calendar_link: string | null;
        school_fully_staffed: string | null;
        school_open_roles_grades: Array<number> | null;
        school_open_roles_subjects: Array<string> | null;
        school_open_to_emergency_credentials: string | null;
        custom_response_message: string | null;
        last_preferences_updated_by: 'principal' | 'district_admin' | null;
        district_is_active: boolean | null;
        district_tier: 'posting_only' | 'ats_lite' | 'ats_full';
        onboarding_status: 'active' | 'active_dormant' | 'inactive' | 'pending_approval';
    };
    /**
     * Created school principal information (pending approval)
     */
    201: {
        id: number;
        school_nces_id: string;
        first_name: string;
        last_name: string;
        on_connect: boolean;
        email: string | null;
        phone_number: string | null;
        cell_phone_number: string | null;
        school_calendar_link: string | null;
        school_fully_staffed: string | null;
        school_open_roles_grades: Array<number> | null;
        school_open_roles_subjects: Array<string> | null;
        school_open_to_emergency_credentials: string | null;
        custom_response_message: string | null;
        last_preferences_updated_by: 'principal' | 'district_admin' | null;
        district_is_active: boolean | null;
        district_tier: 'posting_only' | 'ats_lite' | 'ats_full';
        onboarding_status: 'active' | 'active_dormant' | 'inactive' | 'pending_approval';
    };
};

export type PostApiInternalConnectSchoolSignupResponse = PostApiInternalConnectSchoolSignupResponses[keyof PostApiInternalConnectSchoolSignupResponses];

export type PostApiInternalConnectSchoolsMatchableData = {
    body?: {
        school_nces_ids?: Array<string> | null;
        onboarding_status?: 'active' | 'active_dormant' | 'inactive' | 'pending_approval' | null;
        include_dashboard_url?: boolean;
    };
    path?: never;
    query?: never;
    url: '/api/internal/connect/schools/matchable/';
};

export type PostApiInternalConnectSchoolsMatchableResponses = {
    /**
     * List of matchable schools
     */
    200: Array<{
        school_nces_id: string;
        first_name: string;
        last_name: string;
        email: string | null;
        phone_number: string | null;
        cell_phone_number: string | null;
        school_calendar_link: string | null;
        school_open_roles_grades: Array<string>;
        school_open_roles_subjects: Array<string> | null;
        school_open_to_emergency_credentials: string | null;
        school_fully_staffed: string | null;
        onboarding_status: 'active' | 'active_dormant' | 'inactive' | 'pending_approval';
        dashboard_url: string | null;
    }>;
};

export type PostApiInternalConnectSchoolsMatchableResponse = PostApiInternalConnectSchoolsMatchableResponses[keyof PostApiInternalConnectSchoolsMatchableResponses];

export type GetApiInternalConnectUserByUserIdResumeData = {
    body?: never;
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/resume/';
};

export type GetApiInternalConnectUserByUserIdResumeResponses = {
    /**
     * Resume URL for a user (S3 presigned)
     */
    200: {
        resume_url?: string | null;
    };
};

export type GetApiInternalConnectUserByUserIdResumeResponse = GetApiInternalConnectUserByUserIdResumeResponses[keyof GetApiInternalConnectUserByUserIdResumeResponses];

export type GetApiInternalConnectRolesByRoleIdData = {
    body?: never;
    path: {
        role_id: number;
    };
    query?: never;
    url: '/api/internal/connect/roles/{role_id}';
};

export type GetApiInternalConnectRolesByRoleIdResponses = {
    200: {
        date_posted?: string;
        created_at: string;
        employment_type: 'full_time' | 'part_time';
        job_url: string;
        job_description: string | null;
        pooled_posting_type: 'pooled_posting' | 'single_posting';
        subcategories: Array<string>;
        ai_subcategories: Array<'agriculture' | 'business_marketing' | 'cte_industrial' | 'cte_other' | 'comp_sci' | 'dance' | 'early_childhood' | 'elementary_multiple' | 'english_as_second_language' | 'family_consumer_sciences' | 'foreign_language_chinese' | 'foreign_language_french' | 'foreign_language_german' | 'foreign_language_latin' | 'foreign_language_other' | 'foreign_language_spanish' | 'gifted_education' | 'health' | 'language_arts' | 'library_and_media' | 'math' | 'music_choral' | 'music_general' | 'other' | 'physical_education' | 'reading' | 'science' | 'social_studies' | 'special_education_comprehensive' | 'special_education_general' | 'theater' | 'visual_arts'>;
        id: number;
        title: string;
        salary_min: number;
        salary_max: number;
        district_nces_id: string | null;
    };
};

export type GetApiInternalConnectRolesByRoleIdResponse = GetApiInternalConnectRolesByRoleIdResponses[keyof GetApiInternalConnectRolesByRoleIdResponses];

export type GetApiInternalConnectCandidatesMatchableData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/internal/connect/candidates/matchable/';
};

export type GetApiInternalConnectCandidatesMatchableResponses = {
    /**
     * List of matchable (active-seeker) candidates
     */
    200: Array<{
        id: number;
        first_name: string;
        last_name: string;
        phone_cell: string | null;
        email: string;
        is_active: boolean;
        geocoded_location: {
            latitude: string;
            longitude: string;
        } | null;
        miles_within: string;
        preferred_categories_connect: Array<string> | null;
        preferred_grades: Array<string>;
        credentials: Array<string>;
        connect_candidate_tier: 'tier_1' | 'tier_2' | 'none';
        schools_to_not_match: Array<string> | null;
        preferred_state_ids: Array<number>;
        years_of_teaching_experience: 'one_to_two_years' | 'three_to_five_years' | 'six_to_nine_years' | 'ten_plus_years' | 'substitute_part_time_aide' | 'no_teaching_experience';
        has_valid_credential_manually_verified: boolean;
        job_seeking_status_updated_at: string | null;
    }>;
};

export type GetApiInternalConnectCandidatesMatchableResponse = GetApiInternalConnectCandidatesMatchableResponses[keyof GetApiInternalConnectCandidatesMatchableResponses];

export type PutApiInternalConnectUserByUserIdJobSeekingStatusData = {
    body?: {
        job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work';
    };
    path: {
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/job-seeking-status/';
};

export type PutApiInternalConnectUserByUserIdJobSeekingStatusResponses = {
    /**
     * Updated candidate job seeking status
     */
    200: {
        user_id: number;
        job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work';
        job_seeking_status_updated_at: string | null;
        has_status_changed: boolean;
    };
};

export type PutApiInternalConnectUserByUserIdJobSeekingStatusResponse = PutApiInternalConnectUserByUserIdJobSeekingStatusResponses[keyof PutApiInternalConnectUserByUserIdJobSeekingStatusResponses];

export type PostApiInternalSessionValidateData = {
    body?: {
        session_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/internal/session/validate/';
};

export type PostApiInternalSessionValidateResponses = {
    /**
     * Session validation result
     */
    200: {
        valid: true;
        user_id: number;
        hijacked_by_id: number | null;
        detail: null;
    } | {
        valid: false;
        detail: string;
    };
};

export type PostApiInternalSessionValidateResponse = PostApiInternalSessionValidateResponses[keyof PostApiInternalSessionValidateResponses];

export type GetApiUserByUserIdData = {
    body?: never;
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/user/{user_id}/';
};

export type GetApiUserByUserIdResponses = {
    200: {
        id: number;
        first_name: string | null;
        last_name: string | null;
        credentials: Array<{
            state: number | null;
            subject: {
                id: number;
            } | null;
            status: {
                id: number;
            } | null;
            grade: {
                id: number;
            } | null;
            issue_date: string | null;
            expiration_date: string | null;
            license_number: string | null;
            credential_provided_license_id?: string;
            credential_provided_name?: string;
            credential_provided_proof_img: string | null;
            id: number;
        }>;
        education: Array<{
            id: number;
            school_name: string | null;
            major_enum: number | null;
            degree: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | null;
            school: {
                name: string;
                type: 'default';
            } | null;
            gpa: string;
            gpa_out_of: string;
            start_date: string | null;
            end_date: string | null;
        }>;
        profile: {
            phone_cell: string;
            resume: string | null;
            years_of_teaching_experience: YearsOfTeachingExperience;
            is_eligible_to_work_in_us: boolean;
            connect_first_profile_setup: string | null;
            credential_eligibility_status: 'open_to_emergency_credentials' | 'closed_to_emergency_credentials' | null;
        } | null;
    };
};

export type GetApiUserByUserIdResponse = GetApiUserByUserIdResponses[keyof GetApiUserByUserIdResponses];

export type PatchApiUserByUserIdData = {
    body?: {
        first_name?: string;
        last_name?: string;
        credentials?: Array<{
            state: number | null;
            subject: {
                id: number;
            } | null;
            status?: {
                id: number;
            } | null;
            grade?: {
                id: number;
            } | null;
            issue_date?: string | null;
            expiration_date?: string | null;
            license_number?: string | null;
            credential_provided_license_id?: string;
            credential_provided_name?: string;
            credential_provided_proof_img: string | null;
            id?: number | null;
        }>;
        connect_first_profile_setup?: string;
        education?: Array<{
            university: number | null;
            major_enum: number | null;
            degree: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | null;
            school: string | null;
            gpa: string;
            gpa_out_of: string;
            start_date: string | null;
            end_date: string | null;
        }>;
        profile?: {
            phone_cell?: string;
            resume?: string;
            years_of_teaching_experience?: YearsOfTeachingExperience;
            is_eligible_to_work_in_us?: boolean;
            credential_eligibility_status?: 'open_to_emergency_credentials' | 'closed_to_emergency_credentials' | null;
        };
    };
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/user/{user_id}/';
};

export type PatchApiUserByUserIdResponses = {
    200: {
        id: number;
        first_name: string | null;
        last_name: string | null;
        credentials: Array<{
            state: number | null;
            subject: {
                id: number;
            } | null;
            status: {
                id: number;
            } | null;
            grade: {
                id: number;
            } | null;
            issue_date: string | null;
            expiration_date: string | null;
            license_number: string | null;
            credential_provided_license_id?: string;
            credential_provided_name?: string;
            credential_provided_proof_img: string | null;
            id: number;
        }>;
        education: Array<{
            id: number;
            school_name: string | null;
            major_enum: number | null;
            degree: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | null;
            school: {
                name: string;
                type: 'default';
            } | null;
            gpa: string;
            gpa_out_of: string;
            start_date: string | null;
            end_date: string | null;
        }>;
        profile: {
            phone_cell: string;
            resume: string | null;
            years_of_teaching_experience: YearsOfTeachingExperience;
            is_eligible_to_work_in_us: boolean;
            connect_first_profile_setup: string | null;
            credential_eligibility_status: 'open_to_emergency_credentials' | 'closed_to_emergency_credentials' | null;
        } | null;
    };
};

export type PatchApiUserByUserIdResponse = PatchApiUserByUserIdResponses[keyof PatchApiUserByUserIdResponses];

export type GetApiUserDiscoverInfoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/user-discover-info/';
};

export type GetApiUserDiscoverInfoResponses = {
    200: {
        credentials: Array<{
            id: number;
            subject: {
                id: number;
                value: string | null;
                label: string | null;
                show_in_connect: boolean;
                show_in_ats: boolean;
                credential_group: 'teaching';
            } | null;
            credential_verification: {
                id: number;
                created: string;
                modified: string;
                status: 'ineligible_for_state_verification' | 'pending_manual_verification' | 'failed_verification' | 'passed_manual_verification_pending' | 'passed_auto_verification' | 'pending_auto_verification' | 'passed_manual_verification' | 'failed_auto_verification';
                auto_verification_notes: string | null;
                credential: number;
            } | null;
        }>;
        education: Array<{
            id: number;
            major_enum: number | null;
            degree: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | null;
        }>;
        first_name: string;
        last_name: string;
        profile: {
            is_eligible_to_work_in_us: boolean | null;
            resume: string | null;
            years_of_teaching_experience: 'one_to_two_years' | 'three_to_five_years' | 'six_to_nine_years' | 'ten_plus_years' | 'substitute_part_time_aide' | 'no_teaching_experience';
            credential_eligibility_status: 'open_to_emergency_credentials' | 'closed_to_emergency_credentials' | null;
        } | null;
        resume_verification: {
            status: 'failed_manual_verification' | 'manually_verified' | 'pending_manual_verification';
        } | null;
        preference: {
            categories_connect: Array<'agriculture' | 'business_marketing' | 'cte_industrial' | 'cte_other' | 'comp_sci' | 'dance' | 'early_childhood' | 'elementary_multiple' | 'english_as_second_language' | 'family_consumer_sciences' | 'foreign_language_chinese' | 'foreign_language_french' | 'foreign_language_german' | 'foreign_language_latin' | 'foreign_language_other' | 'foreign_language_spanish' | 'gifted_education' | 'health' | 'language_arts' | 'library_and_media' | 'math' | 'music_choral' | 'music_general' | 'other' | 'physical_education' | 'reading' | 'science' | 'social_studies' | 'special_education_comprehensive' | 'special_education_general' | 'theater' | 'visual_arts'> | null;
            geocoded_location: string | null;
            grades: Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13> | null;
            job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work';
            location: string | null;
            states: Array<number>;
            miles_within: string | null;
            geocoded_state: 'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VA' | 'WA' | 'WV' | 'WI' | 'WY' | 'GU' | 'PR' | 'VI' | 'DC';
        } | null;
    };
};

export type GetApiUserDiscoverInfoResponse = GetApiUserDiscoverInfoResponses[keyof GetApiUserDiscoverInfoResponses];

export type GetApiPreferencesByUserIdData = {
    body?: never;
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/preferences/{user_id}/';
};

export type GetApiPreferencesByUserIdResponses = {
    200: {
        states: Array<number>;
        job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work' | null;
        miles_within: MilesWithin;
        location: string;
        relocation_status: 'currently_live_in_area' | 'planning_to_relocate_to_area';
        relocation_preferences: string | null;
        hide_user_from_schools_on_connect: Array<string> | null;
        grades: Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13> | null;
        categories_connect: Array<'agriculture' | 'business_marketing' | 'cte_industrial' | 'cte_other' | 'comp_sci' | 'dance' | 'early_childhood' | 'elementary_multiple' | 'english_as_second_language' | 'family_consumer_sciences' | 'foreign_language_chinese' | 'foreign_language_french' | 'foreign_language_german' | 'foreign_language_latin' | 'foreign_language_other' | 'foreign_language_spanish' | 'gifted_education' | 'health' | 'language_arts' | 'library_and_media' | 'math' | 'music_choral' | 'music_general' | 'other' | 'physical_education' | 'reading' | 'science' | 'social_studies' | 'special_education_comprehensive' | 'special_education_general' | 'theater' | 'visual_arts'> | null;
    };
};

export type GetApiPreferencesByUserIdResponse = GetApiPreferencesByUserIdResponses[keyof GetApiPreferencesByUserIdResponses];

export type PutApiPreferencesByUserIdData = {
    body?: {
        states?: Array<number>;
        job_seeking_status?: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work';
        miles_within?: MilesWithin;
        location?: string;
        relocation_status?: 'currently_live_in_area' | 'planning_to_relocate_to_area';
        relocation_preferences?: string | null;
        hide_user_from_schools_on_connect?: Array<string> | null;
        grades?: Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13>;
        categories_connect?: Array<'agriculture' | 'business_marketing' | 'cte_industrial' | 'cte_other' | 'comp_sci' | 'dance' | 'early_childhood' | 'elementary_multiple' | 'english_as_second_language' | 'family_consumer_sciences' | 'foreign_language_chinese' | 'foreign_language_french' | 'foreign_language_german' | 'foreign_language_latin' | 'foreign_language_other' | 'foreign_language_spanish' | 'gifted_education' | 'health' | 'language_arts' | 'library_and_media' | 'math' | 'music_choral' | 'music_general' | 'other' | 'physical_education' | 'reading' | 'science' | 'social_studies' | 'special_education_comprehensive' | 'special_education_general' | 'theater' | 'visual_arts'>;
    };
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/preferences/{user_id}/';
};

export type PutApiPreferencesByUserIdResponses = {
    200: {
        states: Array<number>;
        job_seeking_status: 'open_to_work_and_matches' | 'open_to_work' | 'closed_to_work' | null;
        miles_within: MilesWithin;
        location: string;
        relocation_status: 'currently_live_in_area' | 'planning_to_relocate_to_area';
        relocation_preferences: string | null;
        hide_user_from_schools_on_connect: Array<string> | null;
        grades: Array<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13> | null;
        categories_connect: Array<'agriculture' | 'business_marketing' | 'cte_industrial' | 'cte_other' | 'comp_sci' | 'dance' | 'early_childhood' | 'elementary_multiple' | 'english_as_second_language' | 'family_consumer_sciences' | 'foreign_language_chinese' | 'foreign_language_french' | 'foreign_language_german' | 'foreign_language_latin' | 'foreign_language_other' | 'foreign_language_spanish' | 'gifted_education' | 'health' | 'language_arts' | 'library_and_media' | 'math' | 'music_choral' | 'music_general' | 'other' | 'physical_education' | 'reading' | 'science' | 'social_studies' | 'special_education_comprehensive' | 'special_education_general' | 'theater' | 'visual_arts'> | null;
    };
};

export type PutApiPreferencesByUserIdResponse = PutApiPreferencesByUserIdResponses[keyof PutApiPreferencesByUserIdResponses];

export type PostApiPreferencesByUserIdRenewOpenToWorkData = {
    body?: never;
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/preferences/{user_id}/renew_open_to_work/';
};

export type PostApiPreferencesByUserIdRenewOpenToWorkResponses = {
    200: unknown;
};

export type PostApiPreferencesByUserIdCloseToWorkData = {
    body?: never;
    path: {
        user_id: string;
    };
    query?: never;
    url: '/api/preferences/{user_id}/close_to_work/';
};

export type PostApiPreferencesByUserIdCloseToWorkResponses = {
    200: unknown;
};

export type GetApiUserCommunicationPreferencesSmsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/user-communication-preferences/sms/';
};

export type GetApiUserCommunicationPreferencesSmsResponses = {
    200: {
        user_id: number;
        message_type: 'sms' | 'email' | 'phone';
        subscription_status: 'subscribed' | 'unsubscribed';
    };
};

export type GetApiUserCommunicationPreferencesSmsResponse = GetApiUserCommunicationPreferencesSmsResponses[keyof GetApiUserCommunicationPreferencesSmsResponses];

export type PostApiUserCommunicationPreferencesData = {
    body?: {
        user_id: number;
        message_type: 'sms' | 'email' | 'phone';
        subscription_status: 'subscribed' | 'unsubscribed';
    };
    path?: never;
    query?: never;
    url: '/api/user-communication-preferences/';
};

export type PostApiUserCommunicationPreferencesResponses = {
    200: {
        user_id: number;
        message_type: 'sms' | 'email' | 'phone';
        subscription_status: 'subscribed' | 'unsubscribed';
    };
};

export type PostApiUserCommunicationPreferencesResponse = PostApiUserCommunicationPreferencesResponses[keyof PostApiUserCommunicationPreferencesResponses];

export type PostApiUploadresumeData = {
    body?: {
        file: string;
    };
    path?: never;
    query?: never;
    url: '/api/uploadresume/';
};

export type PostApiUploadresumeResponses = {
    200: {
        resume: string;
    };
};

export type PostApiUploadresumeResponse = PostApiUploadresumeResponses[keyof PostApiUploadresumeResponses];

export type PostApiUploadCredentialProofData = {
    body?: {
        file: string;
    };
    path?: never;
    query?: never;
    url: '/api/upload_credential_proof/';
};

export type PostApiUploadCredentialProofResponses = {
    200: {
        file_url: string;
    };
};

export type PostApiUploadCredentialProofResponse = PostApiUploadCredentialProofResponses[keyof PostApiUploadCredentialProofResponses];

export type GetApiStateByStateIdData = {
    body?: never;
    path: {
        state_id: number;
    };
    query?: {
        credential_type?: 'connect' | 'ats';
    };
    url: '/api/state/{state_id}/';
};

export type GetApiStateByStateIdResponses = {
    200: {
        credential_subjects: Array<{
            id: number;
            label: string;
            credential_group: 'teaching';
        }> | null;
    };
};

export type GetApiStateByStateIdResponse = GetApiStateByStateIdResponses[keyof GetApiStateByStateIdResponses];

export type GetApiConnectUserSchoolsDataData = {
    body?: never;
    path?: never;
    query: {
        school_ncesid: Array<string>;
    };
    url: '/api/connect-user-schools-data/';
};

export type GetApiConnectUserSchoolsDataResponses = {
    200: Array<{
        id: string;
        expressed_interest: boolean;
        joined_waitlist: boolean;
        saved_school: boolean;
    }>;
};

export type GetApiConnectUserSchoolsDataResponse = GetApiConnectUserSchoolsDataResponses[keyof GetApiConnectUserSchoolsDataResponses];

export type PostApiConnectSchoolConnectionRequestWaitlistData = {
    body?: {
        school_nces_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/connect_school_connection_request_waitlist/';
};

export type PostApiConnectSchoolConnectionRequestWaitlistErrors = {
    /**
     * Bad Request
     */
    400: {
        detail: string | {
            [key: string]: unknown;
        };
    };
    /**
     * User is already on the waitlist for this school
     */
    409: {
        detail: string;
    };
};

export type PostApiConnectSchoolConnectionRequestWaitlistError = PostApiConnectSchoolConnectionRequestWaitlistErrors[keyof PostApiConnectSchoolConnectionRequestWaitlistErrors];

export type PostApiConnectSchoolConnectionRequestWaitlistResponses = {
    /**
     * Successfully added to waitlist
     */
    201: {
        id: number;
        school_nces_id: string;
        user: number;
        created: string;
    };
};

export type PostApiConnectSchoolConnectionRequestWaitlistResponse = PostApiConnectSchoolConnectionRequestWaitlistResponses[keyof PostApiConnectSchoolConnectionRequestWaitlistResponses];

export type GetApiEducationOptionsUniversitiesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/education-options/universities/';
};

export type GetApiEducationOptionsUniversitiesResponses = {
    200: Array<{
        value: number;
        label: string;
    }>;
};

export type GetApiEducationOptionsUniversitiesResponse = GetApiEducationOptionsUniversitiesResponses[keyof GetApiEducationOptionsUniversitiesResponses];

export type GetApiEducationOptionsDegreesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/education-options/degrees/';
};

export type GetApiEducationOptionsDegreesResponses = {
    200: Array<{
        value: number;
        label: string;
    }>;
};

export type GetApiEducationOptionsDegreesResponse = GetApiEducationOptionsDegreesResponses[keyof GetApiEducationOptionsDegreesResponses];

export type GetApiEducationOptionsMajorsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/education-options/majors/';
};

export type GetApiEducationOptionsMajorsResponses = {
    200: Array<{
        value: number;
        label: string;
    }>;
};

export type GetApiEducationOptionsMajorsResponse = GetApiEducationOptionsMajorsResponses[keyof GetApiEducationOptionsMajorsResponses];

export type CoreAuthCohireImpersonationAcquireCreateData = {
    body: CoreImpersonationAcquireRequest;
    path?: never;
    query?: never;
    url: '/api/auth/cohire/impersonation/acquire/';
};

export type CoreAuthCohireImpersonationAcquireCreateErrors = {
    /**
     * No response body
     */
    400: unknown;
    /**
     * No response body
     */
    403: unknown;
    /**
     * No response body
     */
    404: unknown;
    /**
     * No response body
     */
    409: unknown;
};

export type CoreAuthCohireImpersonationAcquireCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CoreAuthCohireImpersonationAcquireCreateResponse = CoreAuthCohireImpersonationAcquireCreateResponses[keyof CoreAuthCohireImpersonationAcquireCreateResponses];

export type CoreAuthCohireImpersonationReleaseCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/cohire/impersonation/release/';
};

export type CoreAuthCohireImpersonationReleaseCreateErrors = {
    /**
     * No response body
     */
    403: unknown;
};

export type CoreAuthCohireImpersonationReleaseCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CoreAuthCohireImpersonationReleaseCreateResponse = CoreAuthCohireImpersonationReleaseCreateResponses[keyof CoreAuthCohireImpersonationReleaseCreateResponses];

export type CoreAuthInternalUsersCreateAtsUserCreateData = {
    body: CoreInput;
    path?: never;
    query?: never;
    url: '/api/auth/internal/users/create-ats-user/';
};

export type CoreAuthInternalUsersCreateAtsUserCreateErrors = {
    409: CoreConflict;
};

export type CoreAuthInternalUsersCreateAtsUserCreateError = CoreAuthInternalUsersCreateAtsUserCreateErrors[keyof CoreAuthInternalUsersCreateAtsUserCreateErrors];

export type CoreAuthInternalUsersCreateAtsUserCreateResponses = {
    201: CoreOutput;
};

export type CoreAuthInternalUsersCreateAtsUserCreateResponse = CoreAuthInternalUsersCreateAtsUserCreateResponses[keyof CoreAuthInternalUsersCreateAtsUserCreateResponses];

export type CoreGetCandidateApplicationsData = {
    body?: never;
    path: {
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/applications/';
};

export type CoreGetCandidateApplicationsResponses = {
    200: CoreInternalCandidateApplicationsResponse;
};

export type CoreGetCandidateApplicationsResponse = CoreGetCandidateApplicationsResponses[keyof CoreGetCandidateApplicationsResponses];

export type CoreCreateCandidateApplicationData = {
    body: CoreInternalApplicationCreateRequest;
    path: {
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/applications/';
};

export type CoreCreateCandidateApplicationResponses = {
    201: CoreInternalApplication;
};

export type CoreCreateCandidateApplicationResponse = CoreCreateCandidateApplicationResponses[keyof CoreCreateCandidateApplicationResponses];

export type CoreGetCandidateApplicationData = {
    body?: never;
    path: {
        application_id: number;
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/applications/{application_id}/';
};

export type CoreGetCandidateApplicationResponses = {
    200: CoreInternalApplication;
};

export type CoreGetCandidateApplicationResponse = CoreGetCandidateApplicationResponses[keyof CoreGetCandidateApplicationResponses];

export type CoreUpdateCandidateApplicationData = {
    body?: CorePatchedInternalApplicationUpdateRequest;
    path: {
        application_id: number;
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/applications/{application_id}/';
};

export type CoreUpdateCandidateApplicationResponses = {
    200: CoreInternalApplication;
};

export type CoreUpdateCandidateApplicationResponse = CoreUpdateCandidateApplicationResponses[keyof CoreUpdateCandidateApplicationResponses];

export type CoreSubmitCandidateApplicationData = {
    body?: never;
    path: {
        application_id: number;
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/applications/{application_id}/submit/';
};

export type CoreSubmitCandidateApplicationResponses = {
    200: CoreInternalApplication;
};

export type CoreSubmitCandidateApplicationResponse = CoreSubmitCandidateApplicationResponses[keyof CoreSubmitCandidateApplicationResponses];

export type CoreWithdrawCandidateApplicationData = {
    body?: never;
    path: {
        application_id: number;
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/applications/{application_id}/withdraw/';
};

export type CoreWithdrawCandidateApplicationErrors = {
    /**
     * Application not found.
     */
    404: unknown;
};

export type CoreWithdrawCandidateApplicationResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CoreWithdrawCandidateApplicationResponse = CoreWithdrawCandidateApplicationResponses[keyof CoreWithdrawCandidateApplicationResponses];

export type CoreUploadCandidateFileData = {
    body?: {
        file: Blob | File;
    };
    path: {
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/files/';
};

export type CoreUploadCandidateFileResponses = {
    201: CoreInternalCandidateFile;
};

export type CoreUploadCandidateFileResponse = CoreUploadCandidateFileResponses[keyof CoreUploadCandidateFileResponses];

export type CoreGetJobApplicationSectionsData = {
    body?: never;
    path: {
        role_id: number;
        user_id: number;
    };
    query?: never;
    url: '/api/internal/connect/user/{user_id}/jobs/{role_id}/application-sections/';
};

export type CoreGetJobApplicationSectionsResponses = {
    200: Array<CoreInternalApplicationSection>;
};

export type CoreGetJobApplicationSectionsResponse = CoreGetJobApplicationSectionsResponses[keyof CoreGetJobApplicationSectionsResponses];

export type CoreInternalDistrictUsersRetrieveData = {
    body?: never;
    path: {
        nces_id: string;
    };
    query?: never;
    url: '/api/internal/district/{nces_id}/users/';
};

export type CoreInternalDistrictUsersRetrieveResponses = {
    200: CoreDistrictUsersResponse;
};

export type CoreInternalDistrictUsersRetrieveResponse = CoreInternalDistrictUsersRetrieveResponses[keyof CoreInternalDistrictUsersRetrieveResponses];

export type CoreGetExamOptionSubjectsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/internal/exam-options/subjects/';
};

export type CoreGetExamOptionSubjectsResponses = {
    200: Array<CoreInternalExamSubject>;
};

export type CoreGetExamOptionSubjectsResponse = CoreGetExamOptionSubjectsResponses[keyof CoreGetExamOptionSubjectsResponses];

export type CoreGetExamOptionTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/internal/exam-options/types/';
};

export type CoreGetExamOptionTypesResponses = {
    200: Array<CoreInternalExamType>;
};

export type CoreGetExamOptionTypesResponse = CoreGetExamOptionTypesResponses[keyof CoreGetExamOptionTypesResponses];

export type CoreGetStateCredentialGradesData = {
    body?: never;
    path: {
        abbreviation: string;
    };
    query?: never;
    url: '/api/internal/states/{abbreviation}/credential-grades/';
};

export type CoreGetStateCredentialGradesResponses = {
    200: Array<CoreInternalCredentialGrade>;
};

export type CoreGetStateCredentialGradesResponse = CoreGetStateCredentialGradesResponses[keyof CoreGetStateCredentialGradesResponses];

export type CoreGetStateCredentialStatusesData = {
    body?: never;
    path: {
        abbreviation: string;
    };
    query?: never;
    url: '/api/internal/states/{abbreviation}/credential-statuses/';
};

export type CoreGetStateCredentialStatusesResponses = {
    200: Array<CoreInternalCredentialStatus>;
};

export type CoreGetStateCredentialStatusesResponse = CoreGetStateCredentialStatusesResponses[keyof CoreGetStateCredentialStatusesResponses];

export type CoreValidateTokenData = {
    body: CoreTokenValidationRequest;
    path?: never;
    query?: never;
    url: '/api/internal/token/validate/';
};

export type CoreValidateTokenErrors = {
    400: CoreInvalidTokenResponse;
};

export type CoreValidateTokenError = CoreValidateTokenErrors[keyof CoreValidateTokenErrors];

export type CoreValidateTokenResponses = {
    200: CoreTokenValidationResult;
};

export type CoreValidateTokenResponse = CoreValidateTokenResponses[keyof CoreValidateTokenResponses];

export type CoreInternalUserNotificationDataRetrieveData = {
    body?: never;
    path: {
        user_id: number;
    };
    query?: never;
    url: '/api/internal/user/notification-data/{user_id}/';
};

export type CoreInternalUserNotificationDataRetrieveResponses = {
    200: CoreNotificationData;
};

export type CoreInternalUserNotificationDataRetrieveResponse = CoreInternalUserNotificationDataRetrieveResponses[keyof CoreInternalUserNotificationDataRetrieveResponses];
